/* Eaphi の窓口。LOOM(loom.eaphi.co.jp) とやり取りする。
   考え方: まず自分で解決してもらう。会話は「始める」を押したときに初めて作る。
   🔴 合言葉(visitorKey)はこのブラウザにだけ保存する。これが会話の持ち主の証明になる。 */
(function () {
  var C = window.LOOM_CHAT || {};
  var API = (C.api || "https://loom.eaphi.co.jp") + "/api/chat/public";
  var KEY = "eaphi_chat_key";
  /* 書きかけの本文とご用件だけを、このタブに置いておく（お名前・メール・電話・添付は置かない）。 */
  var DRAFT = "loom_chat_draft", DRAFT_VERSION = 2, DRAFT_TTL = 24 * 60 * 60 * 1000, DRAFT_SCOPES = 6;
  /* 送れる1通の上限。snippetのmaxlengthと LOOM 側の受け入れ上限に合わせる。 */
  var MESSAGE_MAX = 2000;
  var topic = "", threadLoaded = false, storageOk = true, draftRestored = false;
  var draftCarried = false, draftLostImage = false, draftSwitched = false, attempt = null;
  var root, scrim, btn, log, ta, send, err, poll = null, lastSnapshot = "";
  var hasConversation = false;
  var threadId = "", threadState = "", lastMessageAt = "", lastMessageId = "";
  var ending = false, confirmEnd = false, newConversation = false, loadEpoch = 0, endSnapshot = null;
  var memoryKey = "", previousFocus, previousOverflow = "", sending = false, loading = false;
  var chatEnabled = false, configReady = false, configRequest = null, background = [];
  var configFailed = false, configRetryTimer = null, configRetries = 0;
  var strings = {}, contactIcons = {}, selectedImage = null, previewUrl = "";
  var supportHash = "#customer-service", retiredChannel = false;
  var lineContactUrl = "", lineFlowStarted = false;
  var lineWelcomeEnabled = false, lineEntryBusy = false;
  var mailControlId = 0;
  /* ── アカウント（会員）のご相談 ──────────────────────────────────────
     同じ店の署名付き App Proxy（/apps/loom-line/chat）だけを使う。
     🔴 どなたかは bootstrap が返す ownerScope で初めて確定する。
        Liquidの account.hint・ブラウザの自己申告・合言葉は本人確認に使わない。
        ownerScope は店と会員を server 側でまとめた不可逆の目印で、これも認証の鍵ではない。 */
  var PROXY_PARENT = "/apps/loom-line", PROXY_CHILD = "/apps/loom-line/chat";
  var CLAIM_RETURN = "loom_chat_claim_return";
  var RESUME = "loom_chat_resume", RESUME_HASH = /^#loom-chat=([A-Za-z0-9_-]{1,64})$/;
  var STATUS_KEYS = { received: "status_received", reviewing: "status_reviewing",
    awaiting_customer: "status_awaiting", resolved: "status_resolved" };
  var mode = "guest";
  var accountEnabled = false, workflowEnabled = false;
  var ownerScope = "", csrfToken = "", memberEpoch = 0, memberBusy = false, authBusy = false, claiming = false;
  var conversations = [], orders = [], convCursor = "", orderCursor = "";
  var convFailed = false, orderFailed = false, memberReady = false, memberNote = "", memberSignIn = false;
  var selectedOrder = "", orderLinking = false, consultation = null, orderNote = "";
  var pendingThread = "", resumeNote = "";
  var conversationMarkup = "", orderMarkup = "";
  function rememberLineIntent() { try { sessionStorage.setItem("loom_line_intent", String(Date.now())); } catch (e) {} }
  function hasLineIntent() {
    try { var at = Number(sessionStorage.getItem("loom_line_intent")); return at > 0 && Date.now() >= at && Date.now() - at < 30 * 60000; } catch (e) { return false; }
  }
  function clearLineIntent() { try { sessionStorage.removeItem("loom_line_intent"); } catch (e) {} }
  function lineStatus(guide) { return guide || document.getElementById("lc-line-status"); }
  async function startLineEntry(guide) {
    if (lineEntryBusy) return;
    lineEntryBusy = true;
    var status = lineStatus(guide);
    status.hidden = false; status.textContent = t("line_preparing");
    status.setAttribute("aria-busy", "true");
    try {
      var endpoint = new URL(C.line.entryUrl, location.origin);
      if (endpoint.origin !== location.origin || endpoint.pathname !== "/apps/loom-line") throw new Error();
      async function call(options) {
        var response = await fetch(endpoint.href, Object.assign({ credentials: "same-origin", cache: "no-store", signal: AbortSignal.timeout(25000) }, options));
        var result = await response.json();
        if (!response.ok) {
          if (result.code === "login_required" || result.code === "link_required") {
            clearLineIntent(); location.assign(C.line.accountUrl);
          }
          throw new Error(t("line_send_error"));
        }
        return result;
      }
      var challenge = await call();
      if (typeof challenge.token !== "string") throw new Error();
      var result = await call({ method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token: challenge.token }) });
      var url = new URL(result.url);
      var account = url.pathname.match(/^\/R\/oaMessage\/(%40[A-Za-z0-9._-]+)\/$/);
      if (!result.ok || !isLineContact(url) || url.hostname !== "line.me" || !account || url.search || url.hash) throw new Error();
      /* 🔴 oaMessageはPCでLINE総合ページへ移る。友だちはトーク、PCは公式アカウントのQRへ進む共通URLを使う。 */
      url = new URL("https://line.me/R/ti/p/" + account[1]);
      clearLineIntent();
      var current = new URL(location.href);
      if (current.searchParams.has("loom_line")) { current.searchParams.delete("loom_line"); history.replaceState(history.state, "", current.pathname + current.search + current.hash); }
      status.textContent = t("line_sent");
      var link = document.createElement("a"); link.href = url.href; link.textContent = t("line_open");
      status.append(" ", link);
      location.assign(url.href);
    } catch (e) {
      status.textContent = t("line_send_error");
      var retry = document.createElement("button"); retry.type = "button"; retry.className = "lc-retry"; retry.textContent = t("retry");
      retry.addEventListener("click", function () { startLineEntry(guide); }); status.append(" ", retry);
    } finally { lineEntryBusy = false; status.removeAttribute("aria-busy"); }
  }
  /* 🔴 新しい文は locales を触らずに足す（テーマの翻訳ファイルは別の担当が持っている）。
     lc-strings に同じキーが足されれば自動でそちらが勝つ。 */
  function japanese() {
    var lang = document.documentElement.lang || "";
    return !lang || /^ja/i.test(lang);
  }
  var BUILT_IN = {
    video_view: function () { return japanese() ? "動画を再生する" : "Play video"; },
    staff_image_view: function () { return japanese() ? "届いた画像を拡大する" : "View the image we sent"; },
  };
  function t(name) { return strings[name] || (BUILT_IN[name] ? BUILT_IN[name]() : name); }

  function isLineContact(url) {
    return url.protocol === "https:" && !url.username && !url.password &&
      (url.hostname === "line.me" || url.hostname === "lin.ee");
  }
  function prepareLineContact(link, url) {
    if (!isLineContact(url)) return;
    lineContactUrl = url.href;
    link.setAttribute("data-lc-line-contact", "");
    if (!C.line || C.line.authenticated !== true || C.line.linked !== true || lineWelcomeEnabled) {
      link.href = C.line && C.line.accountUrl || "/account?loom_line=1#lc-line-settings";
      link.removeAttribute("target"); link.removeAttribute("rel");
    }
    if (!link.hasAttribute("data-lc-line-handler")) {
      link.setAttribute("data-lc-line-handler", "");
      link.addEventListener("click", async function (event) {
        rememberLineIntent();
        if (!C.line || !C.line.authenticated || !C.line.linked || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!configReady) await refreshConfig();
        if (!configReady || !lineContactUrl) { var status = lineStatus(); status.hidden = false; status.textContent = t("line_unavailable"); return; }
        if (lineWelcomeEnabled) startLineEntry();
        else location.assign(lineContactUrl);
      });
    }
  }
  function prepareLineLoginReturn() {
    if (!C.line || C.line.authenticated || !/\/account\/login\/?$/.test(location.pathname)) return;
    var requested = new URL(location.href).searchParams.get("return_url");
    if (!requested) return;
    var destination = new URL(C.line.accountUrl, location.origin), requestedUrl;
    try { requestedUrl = new URL(requested, location.origin); } catch (e) { return; }
    if (requestedUrl.origin !== location.origin || requestedUrl.pathname !== destination.pathname ||
        requestedUrl.searchParams.get("loom_line") !== "1") return;
    var form = document.querySelector('form[action="/account/login"], form[action$="/account/login"]');
    if (!form) return;
    function preserveReturn() {
      var field = form.querySelector('input[name="return_url"]');
      if (!field) { field = document.createElement("input"); field.type = "hidden"; field.name = "return_url"; form.append(field); }
      field.value = destination.pathname + destination.search + destination.hash;
    }
    /* 🔴 本番のログインフォームは return_url が空。LINEの案内を始めた場合だけ固定の戻り先を補う。 */
    preserveReturn(); form.addEventListener("submit", preserveReturn, true);
  }
  function continueLineContact() {
    var settings = document.getElementById("lc-line-settings"), guide = document.getElementById("lc-line-guide");
    if (lineFlowStarted || !settings || !guide || !C.line || C.line.authenticated !== true ||
        new URL(location.href).searchParams.get("loom_line") !== "1") return;
    lineFlowStarted = true;
    guide.hidden = false;
    settings.scrollIntoView({ block: "center", behavior: "auto" });
    settings.focus({ preventScroll: true });
    if (C.line.linked !== true) {
      guide.textContent = t("line_link_hint");
      return;
    }
    guide.textContent = t("line_opening");
    refreshConfig().then(function () {
      if (!configReady || !lineContactUrl) { guide.textContent = t("line_unavailable"); return; }
      if (lineWelcomeEnabled) {
        /* 🔴 URLだけで自動送信を始めない。窓口で押した記録が無い場合は本人のクリックを待つ。 */
        if (hasLineIntent()) { startLineEntry(guide); return; }
        guide.textContent = t("line_confirm");
        var start = document.createElement("button"); start.type = "button"; start.className = "lc-retry"; start.textContent = t("line_contact");
        start.addEventListener("click", function () { rememberLineIntent(); startLineEntry(guide); }); guide.append(" ", start);
        return;
      }
      var link = document.createElement("a");
      link.href = lineContactUrl; link.textContent = t("line_contact");
      guide.append(" ", link);
      /* 🔴 戻る操作でLINEを開き直さないよう、消費した案内フラグを先に消す。 */
      var current = new URL(location.href);
      current.searchParams.delete("loom_line"); current.hash = "lc-line-settings";
      history.replaceState(history.state, "", current.pathname + current.search + current.hash);
      location.assign(lineContactUrl);
    });
  }

  function legacySupport(url) {
    return url.hostname === "05705.channel.io" && /^\/(?:home\/?)?$/.test(url.pathname);
  }
  function prepareSupportLinks(container) {
    var links = container.querySelectorAll ? Array.from(container.querySelectorAll("a[href]")) : [];
    if (container.matches && container.matches("a[href]")) links.push(container);
    links.forEach(function (link) {
      var url; try { url = new URL(link.href, location.href); } catch (e) { return; }
      if (legacySupport(url)) { link.setAttribute("href", supportHash); link.removeAttribute("target"); }
    });
  }
  function retireLegacyChat() {
    if (!retiredChannel && document.getElementById("ch-plugin") && typeof window.ChannelIO === "function") {
      window.ChannelIO("shutdown"); retiredChannel = true;
    }
  }
  function openFromLink(link) {
    var drawer = link && link.closest("mobile-navigation[open]");
    if (drawer) {
      if (drawer.focusTrap) drawer.focusTrap.deactivate({ returnFocus: false });
      drawer.open = false;
    }
    open();
    if (drawer) previousFocus = document.querySelector('[aria-controls="' + drawer.id + '"]') || btn;
  }

  var key = function () { try { return localStorage.getItem(KEY) || memoryKey; } catch (e) { return memoryKey; } };
  var setKey = function (v) { memoryKey = v; try { localStorage.setItem(KEY, v); } catch (e) {} };

  /* ── 書きかけの保持 ───────────────────────────────────────────────
     同じタブの戻る・移動・再読込で、送っていない本文とご用件だけを戻す。
     🔴 合言葉は畳んだ値だけを置き場所の名前に使う（保存した下書きから合言葉を取り出せない）。
     🔴 置き場所は 版 / 店 / 会員の要約 / 合言葉の要約 / どの会話か で分ける。
        これが違う下書きは読まないので、他の相談や別の方の内容が混ざらない。 */
  function fold(value) {
    var h = 0x811c9dc5;
    for (var i = 0; i < value.length; i++) { h ^= value.charCodeAt(i); h = (h * 0x01000193) >>> 0; }
    return h.toString(16);
  }
  /* 🔴 置き場所は「どの会話か」まで含める。cur / new だけで分けると、別のタブで会話Aを終了して
     会話Bを始めたあとにこのタブを再読込したとき、Aへ書いた本文をBへ持ち込んでしまう。
     サーバーから今の会話を読むまでは "?" に預かり、読めた時点で本来の置き場所へ移す。
     新規相談は「どの会話のあとの新規か」まで名前に入れるので、別の会話が最新になれば混ざらない。 */
  function conversationScope() {
    if (!threadLoaded) return "?";
    return (newConversation ? "n:" : "t:") + (threadId || "none");
  }
  /* 🔴 置き場所の「どなたの分か」の欄。ゲストは合言葉の要約、会員は server が返した ownerScope。
     Liquidの hint では分けない。本人確認前は会員の本文を保存・復元せず、
     確認後にその方の置き場所だけを使う。アカウントが入れ替わっても、
     前の方の本文は前の方の欄に残り、別のアカウントの画面には出ない。 */
  function ownerSlot() {
    return mode === "member" ? "m:" + (ownerScope || "?") : fold(key() || "");
  }
  /* 🔴 会員の置き場所に、Liquidが描いた時点の会員の要約を混ぜない。
     混ぜると、同じ方でもページを読み直してLiquidの要約が変わった時点で
     自分の書きかけを見失う（A→Bのあとのreloadで、Bの本文が開けなくなる）。
     どなたの分かは ownerScope だけで決める。ゲストの名前は第1段階のまま変えない。 */
  function ownerTag(slot) {
    return slot.slice(0, 2) === "m:" ? "" : String(C.draftScope || "");
  }
  function scopeFor(conversation, owner) {
    var slot = owner === undefined ? ownerSlot() : owner;
    return [DRAFT_VERSION, location.host, ownerTag(slot), slot, conversation].join("|");
  }
  function draftScope() { return scopeFor(conversationScope()); }
  /* 今の会話が決まる前の仮の置き場所。会員も、本人確認済みの ownerScope ごとに分ける。 */
  function provisionalScope() { return scopeFor("?"); }
  function readDrafts() {
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(DRAFT) || "null"); } catch (e) { storageOk = false; return {}; }
    if (!saved || saved.v !== DRAFT_VERSION || !saved.items || typeof saved.items !== "object") return {};
    var fresh = {};
    Object.keys(saved.items).forEach(function (scope) {
      var item = saved.items[scope];
      if (!item || typeof item.body !== "string" || typeof item.at !== "number") return;
      /* 24時間で期限切れ。端末の時計が進んでいた記録も読まない。 */
      var age = Date.now() - item.at;
      if (age < -60000 || age >= DRAFT_TTL) return;
      fresh[scope] = item;
    });
    return fresh;
  }
  function writeDrafts(items) {
    /* 🔴 結果不明の試行は、ほかの会員や相談の下書きが増えても捨てない。
       件数による整理は通常の下書きだけに適用し、試行は確認または24時間の期限まで保つ。 */
    var normal = 0;
    var scopes = Object.keys(items).sort(function (a, b) { return items[b].at - items[a].at; })
      .filter(function (scope) { return items[scope].uncertain || ++normal <= DRAFT_SCOPES; });
    try {
      if (!scopes.length) sessionStorage.removeItem(DRAFT);
      else {
        var kept = {};
        scopes.forEach(function (scope) { kept[scope] = items[scope]; });
        sessionStorage.setItem(DRAFT, JSON.stringify({ v: DRAFT_VERSION, items: kept }));
      }
      storageOk = true;
    } catch (e) { storageOk = false; }
  }
  /* 書きかけを預かる。送信中（結果不明）の記録は、ふつうの書きかけで上書きしない。
     🔴 送信の途中でページを離れても、その記録が残っていなければ再開後に普通の本文として
        送り直してしまう。resolved を指定したときだけ、その印を外す。 */
  function keepDraft(resolved) {
    if (!ta || (mode === "member" && !ownerScope)) return;
    var items = readDrafts(), scope = draftScope(), body = ta.value || "";
    var held = items[scope], pending = !resolved && held && held.uncertain ? held : null;
    /* 🔴 送れたか分からない試行の本文・ご用件を、あとの入力で書き替えない。
       書き替えると「何を送ったか」が記録から消え、届いたか判断できなくなる。
       内容が変わったら試行を別枠へ退避し、書いた本文はこの会話のふつうの書きかけにする。 */
    if (pending && (pending.body !== body || (pending.topic || "") !== topic)) {
      parkAttempt(items, scope);
      pending = null;
      draftCarried = false; draftRestored = false;
      attempt = findAttempt(items, scope);
    }
    if (!body && !topic && !pending && !(mode === "member" && selectedOrder)) delete items[scope];
    else items[scope] = {
      body: body, topic: topic,
      image: !!selectedImage || draftLostImage || !!(pending && pending.image),
      /* 選んだご注文も、この方の置き場所に預ける。読み戻すときは必ず今のアカウントで照合する。 */
      order: mode === "member" ? selectedOrder : "",
      uncertain: !!pending, generation: pending ? pending.generation : 0, at: Date.now(),
      claimReturn: !!(held && held.claimReturn),
    };
    writeDrafts(items);
  }
  function dropDraft(scope) {
    var items = readDrafts();
    delete items[scope || draftScope()];
    writeDrafts(items);
  }
  /* 🔴 送信の直前に、同じ内容を「結果不明」として同期保存する。
     公開APIは同じ本文でも毎回新しい発言として受けるため、応答前に離脱すると送れたか分からない。
     世代（generation）を付けておき、確認できた送信の世代だけを後で消す。 */
  function markSending() {
    if (!ta) return 0;
    var items = readDrafts(), generation = Date.now();
    items[draftScope()] = { body: ta.value || "", topic: topic, image: !!selectedImage,
      order: mode === "member" ? selectedOrder : "",
      uncertain: true, generation: generation, at: generation };
    writeDrafts(items);
    return generation;
  }
  /* 届いたと確認できた世代だけを消す。
     🔴 置き場所が別の内容に入れ替わっていたら触らない（遅い応答であとから書いた本文を消さない）。 */
  function clearSent(scope, generation) {
    var items = readDrafts(), held = items[scope];
    if (held && held.generation !== generation) return;
    delete items[scope];
    writeDrafts(items);
  }
  /* いま書いている内容は上書きしない（遅い応答や再表示で消さないため）。 */
  function restoreDraft() {
    var items = readDrafts(), item = items[draftScope()];
    /* 終了した相談のあとに「新しいお問い合わせ」を書きかけていたら、その状態ごと戻す。
       🔴 終了前の書きかけ（t:A）と新規相談の書きかけ（n:A）が両方残ることがある。
          後から書いたほうが利用者の最新の意図なので、新しいほうを開く。
          いま最新の会話が別のものなら置き場所の名前が違うので、古い新規相談は混ざらない。 */
    if (!newConversation && threadState === "closed" && threadId) {
      var resumed = items[scopeFor("n:" + threadId)];
      if (resumed && (!item || resumed.at > item.at)) {
        loadEpoch++; newConversation = true; lastSnapshot = ""; render([]); item = resumed;
      }
    }
    if (!item || (ta && ta.value)) return;
    if (ta) ta.value = item.body;
    if (item.topic && topicLabel(item.topic) && firstMessage()) topic = item.topic;
    /* 🔴 預けてあったご注文は、まだ「選んでいた」だけ。今のアカウントで持ち主を照合してから出す。 */
    if (mode === "member" && typeof item.order === "string" && item.order) claimOrder(item.order);
    /* 結果不明のまま持ち越した試行は、履歴を確認したと伺うまで送信を開けない。 */
    draftCarried = !!item.uncertain;
    /* 添付はファイルそのものを保存できない。復元した下書きでは必ず無くなったことを伝える。 */
    draftLostImage = !!item.image;
    draftRestored = !draftCarried && (!!item.body || !!topic);
    fitComposer();
  }
  /* 書いた分だけ縦に伸ばす。
     🔴 高さは本文が見えてから測る。会話画面が隠れているあいだは scrollHeight が 0 になり、
        復元した2行目が枠の外に残る。フォーカスは奪わず、最大120pxと端末の文字サイズはCSSのまま。 */
  function fitComposer() {
    if (!ta || !root || !root.classList.contains("talking")) return;
    ta.style.height = "auto";
    ta.style.height = Math.min(ta.scrollHeight, 120) + "px";
  }
  /* 今の会話が読めた時点で一度だけ呼ぶ。取得前に書いた内容は画面のまま預かり直す。
     🔴 仮の置き場所（"?"）の中身は捨てない。消すだけにすると、取得を待つあいだに書いた本文が
        再読込で失われ、結果不明の試行があればふつうの下書きに化けて二重送信につながる。
        今の会話の置き場所へ明示的に移し、そこに未解消の試行があればそれを守る。 */
  function resolveDraft() {
    var items = readDrafts(), provisional = provisionalScope(), here = draftScope();
    var held = items[provisional];
    if (held) {
      delete items[provisional];
      var there = items[here];
      if (!there) items[here] = held;
      else {
        /* 🔴 仮の置き場所と移行先が両方あるとき、どちらも黙って捨てない。
           結果不明は別枠へ退避して確認を求め、いちばん新しい未送信の本文を
           この会話の書きかけとして残す。結果不明が2つなら両方とも退避する。 */
        var plain = [];
        [held, there].forEach(function (record) {
          if (record.uncertain) parkRecord(items, record);
          else plain.push(record);
        });
        var keep = plain.sort(function (a, b) { return b.at - a.at; })[0];
        if (keep) items[here] = keep; else delete items[here];
      }
      writeDrafts(items);
    }
    if (ta && (ta.value || topic)) {
      keepDraft();
      /* 🔴 送信を開ける前に、移行先に残った結果不明の印をこの画面へ反映する。
         取得を待つあいだに書いた本文があっても、確認なしで送れる状態にはしない。 */
      var standing = readDrafts()[here];
      if (standing && standing.uncertain) {
        draftCarried = true;
        draftLostImage = draftLostImage || !!standing.image;
      }
    } else restoreDraft();
    attempt = findAttempt();
  }
  /* 🔴 開いたまま最新の会話が入れ替わったとき。前の相談の書きかけは預けてあるので、
     画面をいったん空にして、この相談の書きかけだけを戻す。
     添付したファイルは保存できないため、黙って別の相談へ送らせない。 */
  function switchDraft() {
    var hadImage = !!selectedImage;
    if (hadImage) clearImage();
    if (ta) { ta.value = ""; ta.style.height = "auto"; }
    topic = ""; draftCarried = false; draftRestored = false; draftLostImage = false;
    lastSnapshot = "";
    restoreDraft();
    fitComposer();
    draftSwitched = true;
    if (hadImage) draftLostImage = true;
    attempt = findAttempt();
  }
  /* 🔴 まだ解決していない試行を、会話を問わず同じ方／同じブラウザの範囲で探す。
     会話が作られる前（t:none）や新規相談（n:...）に残った試行は、
     あとからGETで別の会話IDが返ると、その会話の置き場所だけ見ても見つからない。
     見つけた試行は会話の書きかけとは別に示し、送信済みか未送信かを利用者が選ぶ。 */
  function scopePrefix() {
    var slot = ownerSlot();
    return [DRAFT_VERSION, location.host, ownerTag(slot), slot].join("|") + "|";
  }
  function findAttempt(records, current) {
    var items = records || readDrafts(), here = current || draftScope(), prefix = scopePrefix(), found = "";
    Object.keys(items).forEach(function (scope) {
      if (scope === here || scope.slice(0, prefix.length) !== prefix || !items[scope].uncertain) return;
      if (!found || items[scope].at > items[found].at) found = scope;
    });
    return found ? { scope: found, item: items[found] } : null;
  }
  /* 未解消の試行を、会話の置き場所とは別の名前（a:…）へ移す。
     会話の書きかけとしては読まれず、findAttempt が拾って別枠に出し、送信を止める。
     🔴 名前に世代を入れる。結果不明が2つ残っているとき、1枠へ上書きして片方を消さない。 */
  function parkRecord(items, record) {
    if (!record || !record.uncertain) return false;
    items[scopeFor("a:" + conversationScope() + ":" + (record.generation || record.at))] = record;
    return true;
  }
  function parkAttempt(items, here) {
    if (!parkRecord(items, items[here])) return false;
    delete items[here];
    return true;
  }
  /* 送れる長さは「ご用件の見出し＋本文」の合計。黙って切り詰めず、入力の上限と残りで伝える。 */
  function bodyAllowance() {
    var heading = topicHeading();
    return MESSAGE_MAX - (heading ? heading.length + 2 : 0);
  }
  function overLimit() { return ta ? (ta.value || "").length - bodyAllowance() : 0; }

  /* ── アカウントのご相談 ─────────────────────────────────────────────────
     同じ店の署名付き App Proxy だけを使う。押していただいたときだけ bootstrap する。
     🔴 bootstrap が通るまで、履歴もご注文も出さない。
        断られた／期限が切れた応答のあとは、手元の控えもその場で消す。 */
  function memberUrl(query) {
    var parent, target;
    try {
      parent = new URL((C.line && C.line.entryUrl) || PROXY_PARENT, location.origin);
      target = new URL(PROXY_CHILD, location.origin);
    } catch (e) { return ""; }
    /* Shopifyが署名を付けるのは、この店の決まった親と子の道だけ。ほかへは出さない。 */
    if (parent.origin !== location.origin || parent.pathname !== PROXY_PARENT) return "";
    if (target.origin !== location.origin || target.pathname !== PROXY_CHILD) return "";
    Object.keys(query || {}).forEach(function (name) {
      var value = query[name];
      /* 同じ名前を二度付けない（署名の検証で弾かれる形にしない）。 */
      if (value !== undefined && value !== null && value !== "") target.searchParams.set(name, String(value));
    });
    return target.href;
  }
  /* 署名付きproxyとの一度のやり取り。どの応答も ownerScope を確かめてから画面へ出す。 */
  async function callMember(spec) {
    var url = memberUrl(spec.query);
    if (!url) return { failure: "unavailable" };
    var epoch = memberEpoch;
    var init = { credentials: "same-origin", cache: "no-store", signal: AbortSignal.timeout(spec.timeout || 20000) };
    if (spec.form) { init.method = "POST"; init.body = spec.form; }
    else if (spec.body) {
      init.method = "POST"; init.headers = { "Content-Type": "application/json" };
      init.body = JSON.stringify(spec.body);
    }
    var response, body;
    try {
      response = await fetch(url, init);
      body = await response.json();
    } catch (e) { return { failure: epoch !== memberEpoch ? "stale" : "network" }; }
    /* 🔴 追い抜かれた要求の応答は、成功でも断りでも一切使わない。
       これを後回しにすると、遅れて届いたAの成功やAの401が、
       すでに読み込んだBの画面や ownerScope を書き替えてしまう。 */
    if (epoch !== memberEpoch) return { failure: "stale" };
    if (!body || typeof body !== "object") return { failure: response.ok ? "contract" : "error" };
    if (!response.ok) {
      /* 🔴 断られた応答の中身は使わない。ここから別の方の控えが画面へ出る道を作らない。 */
      var code = typeof body.code === "string" ? body.code : "";
      if (response.status === 403 && code === "token_expired") return { failure: "token_expired" };
      if (response.status === 401 || response.status === 403) return { failure: "login_required" };
      if (response.status === 404) return { failure: "missing" };
      if (response.status === 503 || code === "unavailable") return { failure: "unavailable" };
      return { failure: "error", status: response.status,
        message: typeof body.error === "string" ? body.error : "" };
    }
    if (typeof body.ownerScope !== "string" || !body.ownerScope) return { failure: "contract" };
    /* 🔴 アカウントが入れ替わっていたら、この応答を前の方の画面へ描かない。
       読み込んだ内容は捨て、入れ替わりの手当てをしてから、新しい方の分だけを読み直す。 */
    if (ownerScope && body.ownerScope !== ownerScope) return { failure: "owner", nextOwner: body.ownerScope };
    return { body: body, owner: body.ownerScope };
  }
  /* 画面と手元の控えから、いまのアカウントの分を外す。
     🔴 ここで世代を進める。進めないと、ログアウトや入れ替わりの前に出した要求の応答が
        そのまま通って、消したはずの前の方の履歴・ご注文をもう一度並べてしまう。 */
  function invalidateMemberRequests() {
    memberEpoch++; loadEpoch++;
    var copied = document.getElementById("lc-resume-field");
    if (copied) copied.remove();
    memberBusy = false; authBusy = false; claiming = false; loading = false; sending = false; ending = false; confirmEnd = false;
    if (ta) ta.readOnly = false;
  }
  function clearMemberData(forget) {
    invalidateMemberRequests();
    conversations = []; orders = []; convCursor = ""; orderCursor = "";
    convFailed = false; orderFailed = false; memberReady = false; orderNote = "";
    csrfToken = ""; consultation = null; selectedOrder = ""; orderLinking = false;
    if (forget) ownerScope = "";
    if (mode === "member") {
      threadId = ""; threadState = ""; lastMessageAt = ""; lastMessageId = "";
      hasConversation = false; threadLoaded = false; newConversation = false;
      lastSnapshot = ""; loadEpoch++;
      if (log) render([]);
    }
  }
  /* 画面の入力を片付ける。預けた書きかけは消さない（置き場所に残したまま画面から外す）。 */
  function stashComposer() {
    if (selectedImage) clearImage();
    if (ta) { ta.value = ""; ta.style.height = "auto"; }
    topic = ""; draftCarried = false; draftRestored = false; draftLostImage = false; draftSwitched = false;
    attempt = null;
  }
  /* 🔴 A→Bの入れ替わり（別のタブでのログイン・ログアウト・期限切れ）。
     Aの本文はAの置き場所へ預け、画面からは外す。Aへ向けて出した要求の応答は、
     世代を進めることで受け取らない。Bの分は読み直してから出す。 */
  function switchOwner(next) {
    if (mode === "member") keepDraft();
    clearMemberData(true);
    ownerScope = next || "";
    if (mode === "member") stashComposer();
    memberSignIn = !ownerScope;
    memberNote = ownerScope ? t("account_loading") : t("account_signed_out");
    if (mode === "member") showMemberList();
  }
  function handleMemberFailure(res) {
    if (res.failure === "stale") return;
    if (res.failure === "owner") { switchOwner(res.nextOwner); bootstrapMember(); return; }
    if (res.failure === "login_required") {
      /* 🔴 書きかけはこの方の置き場所に残し、画面には出さない。別の方として送らない。 */
      if (mode === "member") keepDraft();
      clearMemberData(true);
      if (mode === "member") stashComposer();
      memberNote = t("account_signed_out"); memberSignIn = true;
      if (mode === "member") showMemberList();
    } else if (res.failure === "unavailable") { memberNote = t("account_unavailable"); memberSignIn = false; }
    else if (res.failure === "missing") { memberNote = t("resume_missing"); memberSignIn = false; }
    else if (res.failure === "token_expired") { memberNote = t("token_expired"); memberSignIn = false; }
    else { memberNote = res.message || t("account_error"); memberSignIn = false; }
    syncDraft(); updateAvailability();
  }

  function cursorOf(value) { return typeof value === "string" && value ? value : ""; }
  function validOrder(order) {
    return !!order && typeof order === "object" && typeof order.id === "string" && !!order.id &&
      typeof order.number === "string" && !!order.number &&
      (order.placedAt === null || order.placedAt === undefined || typeof order.placedAt === "string");
  }
  /* 🔴 受け取って良い項目だけを読む。担当者・待ち先・内部メモ・次の予定・AIの下書きは読まない。 */
  function validConsultation(item) {
    return !!item && typeof item === "object" && typeof item.id === "string" && !!item.id &&
      typeof item.reference === "string" && !!item.reference &&
      Object.prototype.hasOwnProperty.call(STATUS_KEYS, item.status) &&
      (item.updatedAt === null || item.updatedAt === undefined || typeof item.updatedAt === "string") &&
      (item.order === null || item.order === undefined || validOrder(item.order));
  }
  function statusLabel(status) {
    return Object.prototype.hasOwnProperty.call(STATUS_KEYS, status) ? t(STATUS_KEYS[status]) : "";
  }
  function orderName(order) { return t("order_label").replace("[number]", order.number); }
  function when(iso) {
    var at = new Date(iso).getTime();
    return isFinite(at) ? ago(iso) : "";
  }
  function onDay(iso) {
    var at = new Date(iso);
    if (!isFinite(at.getTime())) return "";
    try { return at.toLocaleDateString(); } catch (e) { return iso.slice(0, 10); }
  }
  function memberBack() { return root.querySelector(".lc-member-back"); }
  function claimOrder(id) {
    selectedOrder = id; revalidateOrder();
  }
  /* 🔴 預かっていたご注文の選択は、いまのアカウントのご注文に見つかるときだけ画面へ出す。
     別のアカウントで選んだ控えや、見えなくなったご注文をそのまま出さない。 */
  function revalidateOrder() {
    if (!selectedOrder) return;
    if (orders.some(function (order) { return order.id === selectedOrder; })) return;
    selectedOrder = ""; orderNote = t("order_dropped");
  }
  function consultationFor(id) {
    return conversations.filter(function (item) { return item.id === id; })[0] || null;
  }
  function adoptConsultation(value) {
    if (value === null || value === undefined) return;
    if (!validConsultation(value)) return;
    consultation = value;
    var known = false;
    conversations = conversations.map(function (item) {
      if (item.id !== value.id) return item;
      known = true; return value;
    });
    if (!known) conversations = [value].concat(conversations);
  }

  function mergedRows(fresh, previous) {
    var ids = {};
    fresh.forEach(function (row) { ids[row.id] = true; });
    return fresh.concat(previous.filter(function (row) { return !ids[row.id]; }));
  }
  async function bootstrapMember(preserveLists) {
    if (authBusy) return false;
    authBusy = true; memberNote = t("account_loading"); memberSignIn = false; updateAvailability();
    var res = await callMember({ query: { action: "bootstrap" } });
    if (res.failure === "stale") return false;
    authBusy = false;
    if (res.failure) {
      if (res.failure !== "owner" && res.failure !== "login_required") suspendMember();
      handleMemberFailure(res); return false;
    }
    var body = res.body;
    if (typeof body.csrfToken !== "string" || !body.csrfToken ||
        !Array.isArray(body.conversations) || !Array.isArray(body.orders)) {
      suspendMember(); memberNote = t("account_error"); updateAvailability(); return false;
    }
    var retaining = preserveLists && memberReady && ownerScope === res.owner;
    ownerScope = res.owner; csrfToken = body.csrfToken;
    conversations = mergedRows(body.conversations.filter(validConsultation), retaining ? conversations : []);
    orders = mergedRows(body.orders.filter(validOrder), retaining ? orders : []);
    if (!retaining) {
      convCursor = cursorOf(body.conversationsNextCursor);
      orderCursor = cursorOf(body.ordersNextCursor);
    }
    memberReady = true; memberNote = ""; memberSignIn = false;
    revalidateOrder();
    updateAvailability();
    return true;
  }
  function suspendMember() {
    if (mode === "member") keepDraft();
    clearMemberData(true);
    if (mode === "member") { stashComposer(); showMemberList(); }
  }
  /* 続きの読み込みは、この方のために出した目印（cursor）でだけ進める。 */
  async function loadMore(what) {
    if (memberBusy || authBusy || !memberReady) return;
    var conversationsPage = what === "conversations";
    var cursor = conversationsPage ? convCursor : orderCursor;
    if (!cursor) return;
    memberBusy = true; updateAvailability();
    var res = await callMember({ query: { action: what, cursor: cursor } });
    if (res.failure === "stale") return;
    memberBusy = false;
    if (res.failure) { handleMemberFailure(res); return; }
    var body = res.body;
    if (conversationsPage) {
      if (!Array.isArray(body.conversations)) { convFailed = true; memberNote = t("account_error"); }
      else {
        var seen = {};
        conversations.forEach(function (item) { seen[item.id] = true; });
        body.conversations.filter(validConsultation).forEach(function (item) {
          if (!seen[item.id]) { seen[item.id] = true; conversations.push(item); }
        });
        convCursor = cursorOf(body.conversationsNextCursor);
      }
    } else if (!Array.isArray(body.orders)) { orderFailed = true; memberNote = t("orders_error"); }
    else {
      var held = {};
      orders.forEach(function (order) { held[order.id] = true; });
      body.orders.filter(validOrder).forEach(function (order) {
        if (!held[order.id]) { held[order.id] = true; orders.push(order); }
      });
      orderCursor = cursorOf(body.ordersNextCursor);
    }
    updateAvailability();
  }

  function showMemberList() {
    mode = "member";
    root.classList.remove("talking");
    root.classList.add("member");
    startPoll();
  }
  async function enterMember(fromResume) {
    if (!accountEnabled) return;
    if (mode !== "member") {
      /* ゲストの画面に書きかけがあれば、ゲストの置き場所へ預けてから移る。 */
      if (ta && (ta.value || topic)) keepDraft();
      mode = "member";
      stashComposer();
      clearMemberData(false);
    }
    showMemberList();
    memberBack().focus();
    updateAvailability();
    var ready = memberReady || await bootstrapMember();
    if (!ready) return;
    var wanted = fromResume ? pendingResume() : "";
    if (!wanted) return;
    /* 🔴 相談のIDはこちらから指定して開く。bootstrapの最初の一覧に出ているかどうかで決めない
       （古いご相談は一覧の次のページにある）。開けるかどうかは server が持ち主を見て決める。
       預かったIDは、開けたとき・はっきり無い／ほかの方のものと分かったときだけ片付ける。 */
    var outcome = await openMemberThread(wanted);
    if (outcome === "ok" || outcome === "missing") clearResume();
    if (outcome === "missing") {
      memberNote = t("resume_missing");
      showMemberList(); updateAvailability();
    }
  }
  /* 会話から一覧へ戻る。書きかけはこの相談の置き場所へ預けてから画面を空にする。 */
  function backToMemberList() {
    keepDraft();
    invalidateMemberRequests();
    stashComposer();
    threadId = ""; threadState = ""; hasConversation = false; newConversation = false;
    threadLoaded = false; consultation = null; lastSnapshot = ""; loadEpoch++;
    resumeNote = ""; orderLinking = false;
    render([]);
    showMemberList();
    updateAvailability();
    memberBack().focus();
  }
  function leaveMember() {
    if (ta && (ta.value || topic)) keepDraft();
    clearMemberData(false);
    mode = "guest";
    stashComposer();
    root.classList.remove("member", "talking");
    memberNote = ""; memberSignIn = false; resumeNote = "";
    threadLoaded = false; lastSnapshot = "";
    updateAvailability();
    load();
    root.querySelector(".lc-start").focus();
  }
  async function openMemberThread(id) {
    if (!memberReady || !id) return "fail";
    if (ta && (ta.value || topic)) keepDraft();
    stashComposer();
    /* 🔴 開く相談はこちらで指定する。応答が別の相談なら出さない（新しい順で勝手に選ばない）。 */
    threadId = id; threadState = ""; newConversation = false; hasConversation = true;
    threadLoaded = false; lastSnapshot = ""; invalidateMemberRequests();
    consultation = consultationFor(id);
    resumeNote = "";
    root.classList.remove("member"); root.classList.add("talking");
    render([]); intake(); updateAvailability();
    var outcome = await loadMember();
    if (outcome === "ok" && root.classList.contains("on") && root.classList.contains("talking")) {
      startPoll();
      (window.innerWidth <= 520 ? root.querySelector(".lc-back") : ta).focus();
      fitComposer();
    }
    return outcome;
  }
  function startMemberConsultation() {
    if (!memberReady || !csrfToken) return;
    if (ta && (ta.value || topic)) keepDraft();
    stashComposer();
    threadId = ""; threadState = ""; hasConversation = false; newConversation = false;
    consultation = null; lastSnapshot = ""; invalidateMemberRequests(); resumeNote = "";
    root.classList.remove("member"); root.classList.add("talking");
    render([]);
    /* 新しいご相談は読み込むものが無いので、ここで書きかけの置き場所が決まる。 */
    threadLoaded = true; resolveDraft();
    intake(); updateAvailability(); fitComposer(); startPoll();
    (window.innerWidth <= 520 ? root.querySelector(".lc-back") : ta).focus();
  }
  async function loadMember() {
    if (loading || ending || document.hidden) return "fail";
    if (!memberReady || !threadId) return "fail";
    loading = true;
    var epoch = loadEpoch;
    var res = await callMember({ query: { action: "conversation", threadId: threadId }, timeout: 12000 });
    if (res.failure === "stale" || epoch !== loadEpoch) return "stale";
    loading = false;
    if (res.failure) {
      if (res.failure !== "stale") document.getElementById("lc-connection").textContent =
        res.failure === "missing" ? t("resume_missing") : t("load_error");
      if (res.failure === "login_required" || res.failure === "owner") handleMemberFailure(res);
      return res.failure === "missing" ? "missing" : res.failure === "stale" ? "stale" : "fail";
    }
    if (epoch !== loadEpoch) return "stale";
    var body = res.body;
    /* 🔴 指定した相談の応答だけを使う。 */
    if (body.threadId !== threadId || !Array.isArray(body.messages)) {
      document.getElementById("lc-connection").textContent = t("load_error");
      return "fail";
    }
    var ms = body.messages;
    if (confirmEnd && endSnapshot && (body.threadId !== endSnapshot.threadId ||
        body.lastMessageAt !== endSnapshot.lastMessageAt || (ms.length ? ms[ms.length - 1].id : "") !== endSnapshot.lastMessageId)) {
      confirmEnd = false; err.textContent = t("end_changed");
    }
    threadState = typeof body.state === "string" ? body.state : "";
    lastMessageAt = typeof body.lastMessageAt === "string" ? body.lastMessageAt : "";
    lastMessageId = ms.length ? ms[ms.length - 1].id : "";
    adoptConsultation(body.consultation);
    var resolving = !threadLoaded;
    threadLoaded = true;
    if (threadState === "closed") confirmEnd = false;
    if (resolving) resolveDraft();
    intake(); updateAvailability();
    document.getElementById("lc-connection").textContent = "";
    var snapshot = JSON.stringify([body.threadId, threadState, ms]);
    if (snapshot !== lastSnapshot) { lastSnapshot = snapshot; render(ms); }
    return "ok";
  }
  /* いま続けている相談に、対象のご注文を結び付ける／外す。実際のご注文は変えない。 */
  async function linkOrder(id) {
    if (!memberReady || !csrfToken || !threadId || memberBusy || authBusy) return;
    memberBusy = true; memberNote = ""; updateAvailability();
    var res = await callMember({ body: { action: "link_order", csrfToken: csrfToken,
      threadId: threadId, orderId: id || null } });
    if (res.failure === "stale") return;
    memberBusy = false;
    if (res.failure) {
      if (res.failure === "token_expired") { handleMemberFailure(res); bootstrapMember(); return; }
      if (res.failure === "login_required" || res.failure === "owner") { handleMemberFailure(res); return; }
      memberNote = t("order_link_error"); updateAvailability(); return;
    }
    if (res.body.ok !== true || !validConsultation(res.body.consultation) || res.body.consultation.id !== threadId) {
      memberNote = t("order_link_error"); updateAvailability(); return;
    }
    adoptConsultation(res.body.consultation);
    selectedOrder = res.body.consultation.order ? res.body.consultation.order.id : "";
    orderLinking = false; orderNote = t("order_linked");
    root.classList.remove("member"); root.classList.add("talking");
    updateAvailability();
    document.getElementById("lc-consult-order-change").focus();
  }
  /* 🔴 この画面で続けている相談を、押していただいたときだけアカウントへ保存する。
     ログインしただけでは保存しない。保存後、この画面の合言葉ではもう読めなくなる。 */
  async function claimConversation() {
    if (claiming || sending || ending || !accountEnabled || mode !== "guest" || !threadId || !key()) return;
    /* 送れたか分からない試行が残っているあいだは動かさない（どちらの置き場所か分からなくなる）。 */
    if (draftCarried || attempt) { err.textContent = t("draft_uncertain"); return; }
    var claimedId = threadId, claimedKey = key(), claimEpoch = memberEpoch;
    claiming = true; updateAvailability();
    var status = document.getElementById("lc-claim-status");
    status.textContent = t("account_loading");
    var ready = csrfToken && memberReady ? true : await bootstrapMember();
    if (claimEpoch !== memberEpoch || mode !== "guest" || threadId !== claimedId || key() !== claimedKey) {
      if (mode === "guest" && threadId === claimedId) {
        claiming = false; status.textContent = memberNote || t("claim_error"); updateAvailability();
      }
      return;
    }
    if (!ready || !csrfToken) {
      claiming = false; status.textContent = memberNote || t("claim_error"); updateAvailability(); return;
    }
    var saved = threadId, carried = ta ? ta.value : "", carriedTopic = topic;
    var res = await callMember({ body: { action: "claim", threadId: saved,
      visitorKey: claimedKey, csrfToken: csrfToken } });
    if (res.failure === "stale") return;
    claiming = false;
    if (res.failure) {
      if (res.failure === "token_expired") { status.textContent = t("token_expired"); bootstrapMember(); return; }
      if (res.failure === "login_required" || res.failure === "owner") { handleMemberFailure(res); return; }
      status.textContent = res.message || t("claim_error"); updateAvailability(); return;
    }
    if (res.body.ok !== true || !validConsultation(res.body.consultation) || res.body.consultation.id !== saved) {
      status.textContent = t("claim_error"); updateAvailability(); return;
    }
    /* 保存できたので、この相談はログインした方だけのものになる。
       手元の合言葉はこの相談には使えないため、持ち越さない（次のゲスト相談では作り直す）。 */
    if (ta && (ta.value || topic)) keepDraft();
    setKey("");
    mode = "member";
    stashComposer();
    conversations = []; convCursor = ""; memberReady = true;
    adoptConsultation(res.body.consultation);
    conversations = [res.body.consultation];
    status.textContent = t("claim_saved");
    var claimedOwner = ownerScope;
    var opened = await openMemberThread(saved);
    if (opened !== "ok" || mode !== "member" || ownerScope !== claimedOwner || threadId !== saved) return;
    /* 書いていた本文は、同じ相談の続きとしてそのまま使えるようにする。 */
    if (carried && ta && !ta.value) {
      ta.value = carried;
      if (carriedTopic && topicLabel(carriedTopic) && firstMessage()) topic = carriedTopic;
      keepDraft(true); fitComposer();
    }
    memberNote = ""; updateAvailability();
  }

  /* 🔴 保存のためのログインを明示したときだけ、同じゲスト相談へ戻す。
     URLや追加session項目に本文・合言葉・会員情報を載せない。戻り先は不透明IDだけ。
     下書きの移動は同じkeyで同じ相談を読めた後に限り、会員の下書きには触れない。 */
  function claimReturnId() {
    try {
      var id = sessionStorage.getItem(CLAIM_RETURN) || "";
      return /^[A-Za-z0-9_-]{1,64}$/.test(id) ? id : "";
    } catch (e) { return ""; }
  }
  function markClaimReturn() {
    if (mode !== "guest" || !threadId || !key() || sending || draftCarried || attempt) return;
    keepDraft();
    var items = readDrafts(), here = draftScope();
    if (items[here] && !items[here].uncertain) {
      items[here].claimReturn = true; writeDrafts(items);
    }
    try { sessionStorage.setItem(CLAIM_RETURN, threadId); } catch (e) {}
  }
  function restoreClaimReturn() {
    var id = claimReturnId();
    if (!id || mode !== "guest") return;
    try { sessionStorage.removeItem(CLAIM_RETURN); } catch (e) {}
    if (id !== threadId || !key()) return;
    var items = readDrafts(), here = draftScope(), tag = fold(key());
    var source = Object.keys(items).filter(function (scope) {
      var parts = scope.split("|");
      return parts.length === 5 && parts[1] === location.host && parts[3] === tag &&
        parts[4] === "t:" + id && items[scope].claimReturn && !items[scope].uncertain;
    }).sort(function (a, b) { return items[b].at - items[a].at; })[0];
    if (!source) return;
    var saved = items[source]; delete saved.claimReturn;
    if (!ta.value && !draftCarried && !attempt) {
      delete items[source]; items[here] = saved;
      writeDrafts(items); restoreDraft();
    } else writeDrafts(items);
  }

  /* ── ほかの端末で続ける ────────────────────────────────────────────
     🔴 渡すのは、この店の同じオリジンと相談のIDだけ。合言葉・認証の情報・メール・
        ご注文の情報はURLに載せない。開けるのは同じアカウントでログインした方だけ。 */
  function resumeLink() {
    return mode === "member" && threadId ? location.origin + "/#loom-chat=" + encodeURIComponent(threadId) : "";
  }
  function readResumeHash() {
    var match = RESUME_HASH.exec(location.hash || "");
    if (!match) return false;
    pendingThread = match[1];
    try { sessionStorage.setItem(RESUME, pendingThread); } catch (e) {}
    /* 共有や履歴に相談IDを残し続けない。ログインを挟んでもこのタブに預けてある。 */
    history.replaceState(history.state, "", location.pathname + location.search);
    return true;
  }
  function pendingResume() {
    if (pendingThread) return pendingThread;
    try { return sessionStorage.getItem(RESUME) || ""; } catch (e) { return ""; }
  }
  function clearResume() {
    pendingThread = "";
    try { sessionStorage.removeItem(RESUME); } catch (e) {}
  }
  /* ログインの入口。戻り先はこの店の同じオリジンの道だけ。相談IDは載せない。 */
  function loginHref() {
    var raw = (C.account && C.account.loginUrl) || "", url;
    try { url = new URL(raw, location.origin); } catch (e) { return ""; }
    if (url.protocol !== "https:" && url.origin !== location.origin) return "";
    if (url.origin === location.origin) url.searchParams.set("return_url", location.pathname);
    return url.href;
  }
  /* リンクから開く。設定を読むまでアカウントが使えるか分からないので、読めてから進む。 */
  async function openForResume() {
    open();
    await refreshConfig();
    if (accountEnabled) enterMember(true);
    else updateAvailability();
  }
  async function copyResume() {
    var link = resumeLink(), status = document.getElementById("lc-resume-status"), epoch = memberEpoch;
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
      if (epoch !== memberEpoch) return;
      resumeNote = t("resume_copied") + " " + t("resume_hint");
    } catch (e) {
      if (epoch !== memberEpoch) return;
      resumeNote = t("resume_manual") + " " + t("resume_hint");
      var field = document.getElementById("lc-resume-field");
      if (!field) {
        field = document.createElement("input");
        field.id = "lc-resume-field"; field.type = "text"; field.readOnly = true;
        field.setAttribute("aria-label", t("resume_copy"));
        status.parentElement.append(field);
      }
      field.value = link; field.focus(); field.select();
    }
    status.textContent = resumeNote;
  }

  /* 入口・一覧・会話の見た目を、いまの状態に合わせる。 */
  function syncAccount() {
    var panel = document.getElementById("lc-account");
    if (!panel) return;
    var login = loginHref();
    panel.hidden = !accountEnabled;
    var entry = document.getElementById("lc-account-entry"), anchor = document.getElementById("lc-account-login");
    /* 署名付きの確認が通っていれば、Liquidの hint が false でもアカウントから進める。 */
    var signedIn = !!ownerScope || !!(C.account && C.account.hint === true);
    entry.hidden = !signedIn;
    entry.disabled = memberBusy || authBusy;
    anchor.hidden = signedIn || !login;
    if (login) anchor.href = login;
    var waiting = pendingResume();
    document.getElementById("lc-account-status").textContent =
      !accountEnabled ? "" : waiting && !signedIn ? t("resume_pending") : memberSignIn ? t("account_signed_out") : "";

    var memberLogin = document.getElementById("lc-member-login");
    document.getElementById("lc-member-status").textContent = memberNote;
    document.getElementById("lc-member-retry").hidden = !memberNote || memberSignIn || memberBusy || authBusy;
    memberLogin.hidden = !memberSignIn || !login;
    if (login) memberLogin.href = login;
    document.getElementById("lc-member-new").hidden = !memberReady || orderLinking;
    renderMember();
    syncConsult();
    var claim = document.getElementById("lc-claim");
    /* ゲストの相談が続いているときだけ、保存の入口を出す。 */
    claim.hidden = !(accountEnabled && mode === "guest" && !!threadId && !!key() &&
      threadState !== "closed" && !newConversation);
    document.getElementById("lc-claim-save").disabled = claiming || memberBusy || authBusy || sending || ending || draftCarried || !!attempt;
    var claimLogin = document.getElementById("lc-claim-login");
    claimLogin.hidden = !memberSignIn || !login;
    if (login) claimLogin.href = login;
  }
  function renderMember() {
    var list = document.getElementById("lc-conv-list");
    if (!list) return;
    var nextConversations = JSON.stringify(conversations);
    if (conversationMarkup !== nextConversations) {
      conversationMarkup = nextConversations;
      list.replaceChildren.apply(list, conversations.map(function (item) {
      var li = document.createElement("li"), button = document.createElement("button");
      button.type = "button"; button.className = "lc-member-row";
      button.setAttribute("data-lc-thread", item.id);
      var title = document.createElement("span"), meta = document.createElement("span");
      title.className = "lc-member-row-h";
      title.textContent = t("reference_label").replace("[reference]", item.reference);
      meta.className = "lc-member-row-meta";
      meta.textContent = [statusLabel(item.status), item.order ? orderName(item.order) : "",
        item.updatedAt ? when(item.updatedAt) : ""].filter(Boolean).join(" · ");
      button.append(title, meta); li.append(button);
      return li;
      }));
    }
    document.getElementById("lc-conv-empty").hidden = !memberReady || !!conversations.length || convFailed;
    document.getElementById("lc-conv-more").hidden = !convCursor || memberBusy || authBusy;
    document.getElementById("lc-conv-h").hidden = !memberReady;

    var picker = document.getElementById("lc-order-list"), rows = [];
    function row(id, label, note) {
      var li = document.createElement("li"), button = document.createElement("button");
      button.type = "button"; button.className = "lc-member-row";
      button.setAttribute("data-lc-order", id);
      button.setAttribute("aria-pressed", String(selectedOrder === id));
      var title = document.createElement("span");
      title.className = "lc-member-row-h"; title.textContent = label;
      button.append(title);
      if (note) {
        var meta = document.createElement("span");
        meta.className = "lc-member-row-meta"; meta.textContent = note;
        button.append(meta);
      }
      li.append(button); rows.push(li);
    }
    if (memberReady) {
      row("", t("order_none"), "");
      orders.forEach(function (order) {
        row(order.id, orderName(order), order.placedAt ? onDay(order.placedAt) : "");
      });
    }
    var nextOrders = JSON.stringify([memberReady, orders, selectedOrder]);
    if (orderMarkup !== nextOrders) {
      orderMarkup = nextOrders;
      picker.replaceChildren.apply(picker, rows);
    }
    document.getElementById("lc-order-empty").hidden = !memberReady || !!orders.length || orderFailed;
    document.getElementById("lc-order-more").hidden = !orderCursor || memberBusy || authBusy;
    document.getElementById("lc-member-start").disabled =
      !memberReady || !csrfToken || memberBusy || authBusy || !chatEnabled;
  }
  function syncConsult() {
    var box = document.getElementById("lc-consult");
    if (!box) return;
    var talking = root.classList.contains("talking");
    var shown = talking && workflowEnabled && !!consultation;
    box.hidden = !shown && !(talking && mode === "member" && (!!threadId || !!selectedOrder));
    document.getElementById("lc-consult-status").textContent =
      shown ? t("status_label").replace("[status]", statusLabel(consultation.status)) : "";
    document.getElementById("lc-consult-ref").textContent =
      shown ? t("reference_label").replace("[reference]", consultation.reference) : "";
    var orderRow = document.getElementById("lc-consult-order");
    var linked = shown && consultation.order ? consultation.order : orders.filter(function (order) { return order.id === selectedOrder; })[0] || null;
    var member = mode === "member";
    orderRow.hidden = !member;
    document.getElementById("lc-consult-order-text").textContent = !member ? ""
      : t("order_current").replace("[order]", linked ? orderName(linked) : t("order_none"));
    document.getElementById("lc-consult-order-change").hidden = !member || !threadId || !memberReady;
    document.getElementById("lc-resume-copy").hidden = !member || !threadId;
    document.getElementById("lc-resume-status").textContent =
      member ? [orderNote, resumeNote].filter(Boolean).join(" ") : "";
  }

  /* ── ご用件 ───────────────────────────────────────────────────────
     任意の選択。最初のメッセージの先頭へ一度だけ添え、本文には書き込まない。 */
  function topicButtons() { return Array.prototype.slice.call(root.querySelectorAll("[data-lc-topic]")); }
  function topicLabel(id) {
    if (!id || !root) return "";
    var button = root.querySelector('[data-lc-topic="' + (/^[a-z]+$/.test(id) ? id : "") + '"]');
    return button ? button.textContent.trim() : "";
  }
  function firstMessage() { return newConversation || !hasConversation; }
  /* 続いている相談はご用件を挟まずそのまま続きへ戻す。合言葉がある間は読み終えるまで出さない。 */
  function topicEligible() { return firstMessage() && (newConversation || !key() || threadLoaded); }
  function topicHeading() {
    var label = topicLabel(topic);
    return label ? t("topic_heading").replace("[topic]", label) : "";
  }
  function syncTopic() {
    var eligible = topicEligible(), label = eligible ? topicLabel(topic) : "";
    document.getElementById("lc-topics").hidden = !eligible;
    topicButtons().forEach(function (button) {
      button.setAttribute("aria-pressed", String(!!label && button.getAttribute("data-lc-topic") === topic));
    });
    document.getElementById("lc-topic-chip").hidden = !label;
    document.getElementById("lc-topic-current-text").textContent = label ? topicHeading() : "";
    /* ご用件の分だけ本文の上限が縮む。入れ替えると残りの文字数もその場で変わる。 */
    if (ta) ta.setAttribute("maxlength", String(bodyAllowance()));
  }
  function draftNote() {
    var lines = [], over = overLimit(), written = !!(ta && ta.value) || !!topic;
    if (draftCarried) lines.push(t("draft_uncertain"));
    else if (draftSwitched) lines.push(t("draft_switched"));
    else if (draftRestored) lines.push(t("draft_restored"));
    /* 🔴 保存できないブラウザで「保存しました」と言わない。 */
    else if (written) lines.push(storageOk ? t("draft_saved") : t("draft_blocked"));
    if (draftLostImage) lines.push(t("draft_image_lost"));
    document.getElementById("lc-draft-note").textContent = lines.join(" ");
    document.getElementById("lc-draft-confirm").hidden = !draftCarried;
    var left = bodyAllowance() - (ta ? (ta.value || "").length : 0);
    document.getElementById("lc-limit").textContent = over > 0 ? t("limit_over").replace("[count]", over)
      : left <= 200 ? t("limit_left").replace("[count]", left) : "";
  }
  /* 別の会話に残った未解消の試行。会話の書きかけとは分けて示し、利用者が結末を選ぶ。 */
  function attemptNote() {
    var box = document.getElementById("lc-attempt");
    box.hidden = !attempt;
    if (!attempt) return;
    document.getElementById("lc-attempt-text").textContent =
      t("attempt_pending") + (attempt.item.image ? " " + t("draft_image_lost") : "");
    document.getElementById("lc-attempt-body").textContent = attempt.item.body;
    /* 書きかけがある画面へ黙って上書きしない。先に今の本文を整えていただく。 */
    document.getElementById("lc-attempt-restore").disabled = !!(ta && ta.value);
  }
  function syncDraft() { syncTopic(); draftNote(); attemptNote(); }

  function fitViewport() {
    if (!root) return;
    var viewport = window.visualViewport;
    if (!root.classList.contains("on") || window.innerWidth > 520) {
      root.style.removeProperty("--lc-viewport-height"); root.style.removeProperty("--lc-viewport-top");
      return;
    }
    /* 🔴 iPhoneなどではキーボードを開いても100dvhが縮まらず、送信欄が隠れる。
       表示中の領域に合わせる。ピンチ拡大中は追従せず、お客様の拡大操作を妨げない。 */
    if (!viewport || viewport.scale !== 1) return;
    root.style.setProperty("--lc-viewport-height", viewport.height + "px");
    root.style.setProperty("--lc-viewport-top", viewport.offsetTop + "px");
  }

  function open() {
    if (root.classList.contains("on")) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    root.inert = false;
    root.classList.add("on"); scrim.classList.add("on");
    btn.setAttribute("aria-expanded", "true");
    background = Array.from(document.body.children).filter(function (el) {
      return el !== root && el !== scrim && el !== btn && !el.inert;
    });
    background.forEach(function (el) { el.inert = true; });
    btn.setAttribute("hidden", ""); document.body.style.overflow = "hidden";
    root.setAttribute("aria-hidden", "false");
    root.querySelector(".lc-x").focus();
    fitViewport();
    refreshConfig();
    /* 🔴 開き直したときに、同じ方のままかを確かめ直す（別のタブでの出入りを見落とさない）。 */
    if (mode === "member" && !authBusy) refreshMember();
    if (root.classList.contains("talking")) { load(); startPoll(); }
    /* 🔴 入口でも一度だけ今の会話を読む。どの会話の書きかけを戻すかは、これが分かるまで決められない。 */
    else if (!threadLoaded) load();
  }
  function close() {
    root.classList.remove("on"); scrim.classList.remove("on");
    fitViewport();
    btn.removeAttribute("hidden"); document.body.style.overflow = previousOverflow;
    root.setAttribute("aria-hidden", "true");
    root.inert = true;
    btn.setAttribute("aria-expanded", "false");
    background.forEach(function (el) { el.inert = false; });
    background = [];
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    stopPoll();
    stopConfigRetry();
  }
  function talk(on) {
    root.classList.toggle("talking", on);
    if (on) {
      /* 会話画面を出したところで、戻した本文の高さを測り直す。 */
      fitComposer();
      intake(); load(); startPoll();
      // スマホは案内を読む前にキーボードで覆わない。入力欄を押したときに開く。
      (window.innerWidth <= 520 ? root.querySelector(".lc-back") : key() ? ta : document.getElementById("lc-name")).focus();
    } else { stopPoll(); root.querySelector(".lc-start").focus(); }
  }

  /* 入口から会話へ。ご用件を選んでも選ばなくても、この一つの入り方だけを使う。 */
  function startTalk() {
    if (!key() && !configReady) { refreshConfig(); return; }
    if (key() || chatEnabled) talk(true);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function hhmm(iso) {
    var d = new Date(iso);
    return ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
  }
  function ago(iso) {
    var m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
    if (m < 1) return t("just_now");
    if (m < 60) return t("minutes_ago").replace("[count]", m);
    if (m < 1440) return t("hours_ago").replace("[count]", Math.floor(m / 60));
    return t("days_ago").replace("[count]", Math.floor(m / 1440));
  }

  /* あいさつは画面で出すだけ。台帳には残さない（お客さまの発言と混ざらないように） */
  function greeting() {
    return '<div class="lc-intro">' + esc(t("greeting")) + "</div>";
  }

  /* お客さまの合言葉が付いた、その方の会話だけの添付URL。
     🔴 会員のご相談では合言葉を使わず、署名付きproxy越しに受け取る（毎回 server が持ち主を確かめる）。 */
  function mediaSrc(id, field, variant) {
    if (mode === "member") {
      var query = {};
      query[field] = id;
      if (variant) query.v = variant;
      return memberUrl(query);
    }
    return API + "?" + field + "=" + id + "&visitorKey=" + encodeURIComponent(key()) +
      (variant ? "&v=" + variant : "");
  }
  /* こちらから送った画像・動画。画像は拡大、動画はその場で再生できるようにする。 */
  function attachment(m) {
    if (!m.media || !/^ms_[a-f0-9]{18}$/.test(m.id)) return "";
    var original = esc(mediaSrc(m.id, "media"));
    var width = Number(m.media.width) || 0, height = Number(m.media.height) || 0;
    if (m.media.kind === "video") {
      /* 🔴 data-lc-media と src は毎回同じにする。値が変わると下の入れ替えで
         今の<video>と結びつかず、再生中の動画が頭に戻る。 */
      return '<video class="lc-video" data-lc-media="' + m.id + '" src="' + original +
        '" poster="' + esc(mediaSrc(m.id, "media", "preview")) + '" controls preload="metadata" playsinline' +
        (width && height ? ' width="' + width + '" height="' + height + '"' : "") +
        ' aria-label="' + esc(t("video_view")) + '"></video>';
    }
    return '<a class="lc-photo" target="_blank" rel="noopener" referrerpolicy="origin" href="' + original +
      '"><img src="' + original + '" width="' + width + '" height="' + height +
      '" alt="' + esc(t("staff_image_view")) + '"></a>';
  }

  function render(ms) {
    var html = ms.length || (threadState === "closed" && !newConversation) ? "" : greeting();
    var lastMine = null, prevDay = "";
    ms.forEach(function (m) {
      var me = m.who === "customer";
      var day = (m.sent_at || "").slice(0, 10);
      if (day !== prevDay) { prevDay = day; html += '<p class="lc-time">' + hhmm(m.sent_at) + "</p>"; }
      var who = me ? t("you") : "Eaphi customer support";
      html += '<div class="lc-m' + (me ? " me" : "") + '">' +
        '<div class="lc-who">' + esc(who) + "</div>" +
        '<div class="lc-row">' +
         '<div class="lc-t">' + esc(m.body) +
        (m.image && /^ms_[a-f0-9]{18}$/.test(m.id) ? '<a class="lc-photo" target="_blank" rel="noopener" referrerpolicy="origin" href="' + esc(mediaSrc(m.id, "image")) + '"><img src="' + esc(mediaSrc(m.id, "image")) + '" width="' + Number(m.image.width) + '" height="' + Number(m.image.height) + '" alt="' + esc(t("image_view")) + '"></a>' : "") +
        attachment(m) + "</div></div></div>";
      if (me) lastMine = m;
    });
    if (lastMine) html += '<p class="lc-stat">' + esc(t("sent")) + ' · ' + esc(ago(lastMine.sent_at)) + "</p>";
    var w = log.parentElement;
    var atBottom = w.scrollHeight - w.scrollTop - w.clientHeight < 80;
    /* 🔴 innerHTML を入れ替えると<video>が作り直され、再生位置と再生中かどうかが失われる
       （8秒ごとの更新で起きる）。同じ発言・同じURLの<video>は作り直さず、
       いまある要素をそのまま新しい並びへ移す。
       根拠は仕様上の挙動（新しい要素は currentTime 0・paused の初期状態で作られる）と
       jsdomでの要素同一性テスト。実ブラウザ（Safari/iOS）での再生継続はまだ未測定。 */
    var holder = document.createElement("div");
    holder.innerHTML = html;
    Array.prototype.forEach.call(holder.querySelectorAll("video[data-lc-media]"), function (fresh) {
      var id = fresh.getAttribute("data-lc-media");
      if (!/^ms_[a-f0-9]{18}$/.test(id)) return;
      var live = log.querySelector('video[data-lc-media="' + id + '"]');
      if (live && live.getAttribute("src") === fresh.getAttribute("src")) fresh.replaceWith(live);
    });
    log.replaceChildren.apply(log, Array.prototype.slice.call(holder.childNodes));
    if (atBottom || sending) w.scrollTop = w.scrollHeight;
  }

  /* 読み直しの入口。会員のご相談は署名付きproxy、ゲストは合言葉の公開APIを使う。 */
  function load() {
    if (mode === "member") refreshMember();
    else loadGuest();
  }
  async function refreshMember() {
    if (authBusy || document.hidden) return;
    var ready = await bootstrapMember(true);
    if (ready && mode === "member" && threadId) loadMember();
  }
  function loadGuest() {
    if (loading || ending || document.hidden) return;
    var k = key();
    if (!k) {
      if (lastSnapshot !== "empty") { lastSnapshot = "empty"; render([]); }
      /* 合言葉が無い＝まだ会話が無いと分かっている。ここで書きかけの置き場所を確定する。 */
      if (!threadLoaded) { threadLoaded = true; resolveDraft(); updateAvailability(); }
      return;
    }
    loading = true; var epoch = loadEpoch;
    fetch(API + "?visitorKey=" + encodeURIComponent(k), { credentials: "omit", cache: "no-store", signal: AbortSignal.timeout(12000) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (j) {
        if (epoch !== loadEpoch) return;
        var ms = j.messages || [];
        if (confirmEnd && endSnapshot && (j.threadId !== endSnapshot.threadId ||
            j.lastMessageAt !== endSnapshot.lastMessageAt || (ms.length ? ms[ms.length - 1].id : "") !== endSnapshot.lastMessageId)) {
          confirmEnd = false; err.textContent = t("end_changed");
        }
        var nextId = j.threadId || "", nextState = j.state || "";
        var nextNew = newConversation && nextId === threadId && nextState === "closed";
        /* 🔴 開いたまま最新の会話が入れ替わることがある（別のタブで終了・新規開始、担当者の操作）。
           切り替える前に、いま画面にある書きかけを「その会話の」置き場所へ預ける。
           会話IDが変わらないpollでは何も動かさないので、入力とフォーカスはそのまま。 */
        var switching = threadLoaded && (nextId !== threadId || nextNew !== newConversation);
        if (switching) keepDraft();
        newConversation = nextNew;
        threadId = nextId; threadState = nextState;
        consultation = validConsultation(j.consultation) && j.consultation.id === threadId ? j.consultation : null;
        lastMessageAt = j.lastMessageAt || ""; lastMessageId = ms.length ? ms[ms.length - 1].id : "";
        hasConversation = !!threadId;
        var resolving = !threadLoaded;
        threadLoaded = true;
        /* 続いている相談・終了済みの相談にご用件は付けない（新規相談のときだけ改めて選ぶ）。 */
        if (hasConversation && !newConversation) topic = "";
        if (threadState === "closed") confirmEnd = false;
        /* 🔴 今の会話が分かってから、その会話の書きかけだけを戻す（取得前の内容は消さない）。 */
        if (resolving) resolveDraft();
        else if (switching) switchDraft();
        restoreClaimReturn();
        intake(); updateAvailability();
        document.getElementById("lc-connection").textContent = "";
        /* 🔴 最新200件に達すると件数は増えない。同じ件数の新しい返信も拾う。
           内容が変わらない間は描き直さず、入力とスクロール位置を維持する。 */
        var snapshot = JSON.stringify([j.threadId, j.state, ms]);
        if (!newConversation && snapshot !== lastSnapshot) { lastSnapshot = snapshot; render(ms); }
      })
      .catch(function () { if (epoch === loadEpoch) document.getElementById("lc-connection").textContent = t("load_error"); })
      .finally(function () { if (epoch === loadEpoch) loading = false; });
  }

  /* 開いている間だけ様子を見る。閉じたら止める（無駄に叩かない） */
  function startPoll() { stopPoll(); poll = setInterval(load, 8000); }
  function stopPoll() { if (poll) { clearInterval(poll); poll = null; } }

  function submit() {
    if (sending || claiming || ending || confirmEnd || (threadState === "closed" && !newConversation) || !configReady || !chatEnabled) return;
    /* 🔴 初回の取得が終わるまで送らない。どの会話への送信かが決まらないうちに送ると、
       結果不明の記録が仮の置き場所に残り、取得の応答が先に届いたときに取り違える。
       その状態で再読込すると、同じ本文をもう一度送れてしまう（公開APIに冪等性が無い）。 */
    if (!threadLoaded) { err.textContent = t("connecting"); load(); return; }
    /* 結果不明を持ち越している間は、履歴を確認したと伺うまで送らない。 */
    if (draftCarried) { err.textContent = t("draft_uncertain"); document.getElementById("lc-draft-confirm").focus(); return; }
    if (attempt) { err.textContent = t("attempt_pending"); document.getElementById("lc-attempt-keep").focus(); return; }
    var body = (ta.value || "").trim();
    if (!body && !selectedImage) return;
    /* 🔴 会員のご相談はここから分かれる。断られたときにゲストの送信へ回さない
       （ログインした方として書いた本文を、名乗りだけの相談として送らない）。 */
    if (mode === "member") { submitMember(body); return; }
    var nameEl = document.getElementById("lc-name"), mailEl = document.getElementById("lc-mail"), phoneEl = document.getElementById("lc-phone");
    var nm = nameEl ? nameEl.value.trim() : "", ml = mailEl ? mailEl.value.trim() : "";
    var ph = phoneEl ? phoneEl.value.normalize("NFKC").replace(/[‐‑‒–—―−ー]/g, "-").trim() : "";
    /* はじめの一通はメール必須。お名前と電話番号は任意。 */
    if (!hasConversation && !ml) {
      err.textContent = t("email_required");
      if (mailEl) mailEl.focus();
      return;
    }
    if (ml && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(ml)) {
      err.textContent = t("email_invalid");
      return;
    }
    if (ph && (!/^\+?[0-9 ()-]+$/.test(ph) || !/^\+?\d{7,15}$/.test(ph.replace(/[ ()-]/g, "")))) {
      err.textContent = t("phone_invalid");
      if (phoneEl) phoneEl.focus();
      return;
    }
    /* 🔴 ご用件は選んだ状態から毎回組み立てる。最初のメッセージだけに付き、送れたら外す。
       本文には書き込まないので、選び直しや再送でも見出しが重ならない。 */
    var heading = firstMessage() ? topicHeading() : "";
    var outgoing = heading ? (body ? heading + "\n\n" + body : heading) : body;
    /* 見出しを足した合計が上限を超えるときは、黙って切り詰めず、超えた分をお知らせする。 */
    if (outgoing.length > MESSAGE_MAX) {
      err.textContent = t("limit_over").replace("[count]", outgoing.length - MESSAGE_MAX);
      ta.focus(); return;
    }
    sending = true; send.disabled = true; ta.readOnly = true; err.textContent = "";
    stopPoll();
    /* 🔴 最初の送信で応答が途切れても、受け付け済みの会話を同じ合言葉で確認できるようにする。 */
    if (!key()) {
      var startScope = draftScope();
      setKey(Array.from(crypto.getRandomValues(new Uint8Array(24)), function (b) { return b.toString(16).padStart(2, "0"); }).join(""));
      /* 合言葉はこの送信で初めて作られる。置き場所が変わるので、書きかけを移して控えを残さない。
         🔴 移さないと、合言葉を作ったあとに応答前で離脱したとき本文自体を見失う。 */
      var carried = readDrafts(), moving = carried[startScope];
      delete carried[startScope];
      if (moving) carried[draftScope()] = moving;
      writeDrafts(carried);
    }
    /* 🔴 POSTを出す前に、この送信を結果不明として同期保存する。 */
    var sentScope = draftScope(), sentGeneration = markSending();
    var payload = { message: outgoing, visitorKey: key() };
    if (threadId) { payload.threadId = threadId; payload.startNew = newConversation; }
    if (nm) payload.name = nm;
    if (ml) payload.email = ml;
    if (ph) payload.phone = ph;
    var form = new FormData();
    Object.keys(payload).forEach(function (field) { if (payload[field] !== undefined) form.append(field, payload[field]); });
    if (selectedImage) form.append("image", selectedImage);
    document.getElementById("lc-image-attach").disabled = true;
    document.getElementById("lc-image-remove").disabled = true;
    document.getElementById("lc-talk-status").textContent = selectedImage ? t("image_sending") : "";
    var requestEpoch = memberEpoch;
    fetch(API, { method: "POST", credentials: "omit", signal: AbortSignal.timeout(30000),
      ...(selectedImage ? { body: form } : { headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
      .then(function (res) {
        if (mode !== "guest" || requestEpoch !== memberEpoch) return;
        if (!res.ok) {
          /* 🔴 4xx は受け付けを断られたと分かる（内容の不備・重複の拒否など）。
             結果不明の印だけ外し、本文とご用件は残す。408 は受け取られた可能性があるので除く。
             5xx と想定外の状態は、サーバーが保存したあとに応答だけ失われた可能性があるため、
             未解消の試行として残し、履歴の確認をお願いする。 */
          if (res.status >= 400 && res.status < 500 && res.status !== 408) {
            err.textContent = (res.j || {}).error || t("send_error");
            keepDraft(true);
          } else {
            err.textContent = t("send_uncertain"); draftCarried = true; keepDraft();
          }
          load(); return;
        }
        /* 🔴 HTTP 200 でも契約どおりでなければ成功と決めない。
           {} ・ok:false・threadId欠落・別の会話IDは、結果不明として本文と試行を残す。
           新規相談（startNew）のときだけ、返ってくる会話IDが変わることを許す。 */
        var replied = res.j || {};
        var accepted = replied.ok === true && typeof replied.threadId === "string" && !!replied.threadId &&
          (replied.visitorKey === undefined ||
            (typeof replied.visitorKey === "string" && replied.visitorKey.length >= 24)) &&
          (payload.startNew === true || !payload.threadId || replied.threadId === payload.threadId);
        if (!accepted) {
          err.textContent = t("send_uncertain"); draftCarried = true; keepDraft(); load(); return;
        }
        if (replied.visitorKey) setKey(replied.visitorKey);
        /* 🔴 届いたと確認できた世代だけを消す。ご用件も送れたので外す。 */
        clearSent(sentScope, sentGeneration);
        hasConversation = true; newConversation = false;
        topic = ""; draftCarried = false; draftLostImage = false; draftRestored = false; draftSwitched = false;
        threadId = res.j.threadId; threadState = "open"; loadEpoch++;
        consultation = validConsultation(replied.consultation) && replied.consultation.id === threadId ? replied.consultation : null;
        ta.value = ""; ta.style.height = "auto"; clearImage();
        intake();                 /* 連絡先の欄を畳む */
        if (root.classList.contains("on")) ta.focus();
        lastSnapshot = ""; load();
      })
      /* 🔴 送れたか分からない試行は、送信前に残した結果不明の記録をそのまま保つ。
         再読込のあとも「新しい送信」として扱わず、履歴を確認したと伺うまで送信を開けない。 */
      .catch(function () {
        if (mode !== "guest" || requestEpoch !== memberEpoch) return;
        err.textContent = t("send_uncertain"); draftCarried = true; keepDraft();
      })
      .finally(function () {
        if (mode !== "guest" || requestEpoch !== memberEpoch) return;
        sending = false; ta.readOnly = false; updateAvailability();
        if (root.classList.contains("on") && root.classList.contains("talking")) startPoll();
      });
  }

  /* 会員のご相談の送信。どなたかは server が署名から決めるので、こちらから名乗らない。
     🔴 断られてもゲストの送信へ回さない。結果が分からない試行は第1段階と同じ扱いで残す。 */
  async function submitMember(body) {
    if (!memberReady || !csrfToken || memberBusy || authBusy) { err.textContent = t("account_error"); return; }
    var heading = firstMessage() ? topicHeading() : "";
    var outgoing = heading ? (body ? heading + "\n\n" + body : heading) : body;
    if (outgoing.length > MESSAGE_MAX) {
      err.textContent = t("limit_over").replace("[count]", outgoing.length - MESSAGE_MAX);
      ta.focus(); return;
    }
    sending = true; send.disabled = true; ta.readOnly = true; err.textContent = "";
    stopPoll();
    /* 🔴 POSTを出す前に、この送信を結果不明として同期保存する。 */
    var sentScope = draftScope(), sentGeneration = markSending();
    var fresh = !threadId || newConversation;
    var payload = { action: "send", csrfToken: csrfToken, message: outgoing };
    if (threadId && !newConversation) payload.threadId = threadId;
    else if (newConversation) payload.startNew = true;
    /* ご注文を結び付けるのは新しいご相談のときだけ。続いている相談は link_order で変える。 */
    if (fresh && selectedOrder) payload.orderId = selectedOrder;
    var spec = { timeout: 30000 };
    if (selectedImage) {
      var form = new FormData();
      Object.keys(payload).forEach(function (field) { form.append(field, payload[field]); });
      form.append("image", selectedImage);
      spec.form = form;
    } else spec.body = payload;
    document.getElementById("lc-image-attach").disabled = true;
    document.getElementById("lc-image-remove").disabled = true;
    document.getElementById("lc-talk-status").textContent = selectedImage ? t("image_sending") : "";
    var res = await callMember(spec);
    if (res.failure === "stale") return;
    if (res.failure) {
      if (res.failure === "token_expired") {
        /* 🔴 server は書き込む前に断る。印だけ外して本文は残し、合言葉を取り直す。
           こちらから送り直さない（もう一度押していただく）。 */
        err.textContent = t("token_expired"); keepDraft(true); bootstrapMember();
      } else if (res.failure === "login_required") {
        /* 🔴 本文はこの方の置き場所に残す。ゲストとして送り直さない。 */
        err.textContent = t("account_signed_out"); keepDraft(true); handleMemberFailure(res);
      } else if (res.failure === "owner") {
        /* 入れ替わったので、届いたかどうかが分からない。未解消のまま前の方の置き場所に残す。 */
        err.textContent = t("send_uncertain"); draftCarried = true; keepDraft(); handleMemberFailure(res);
      } else if (res.failure === "missing") {
        err.textContent = t("resume_missing"); keepDraft(true);
      } else if (res.failure === "error" && res.status >= 400 && res.status < 500 && res.status !== 408) {
        err.textContent = res.message || t("send_error"); keepDraft(true);
      } else { err.textContent = t("send_uncertain"); draftCarried = true; keepDraft(); }
      afterMemberSend(); return;
    }
    /* 🔴 HTTP 200 でも契約どおりでなければ成功と決めない。
       会員の応答に合言葉は来ない。ownerScope が今の方と一致することも成功の条件にする。 */
    var replied = res.body;
    var accepted = replied.ok === true && typeof replied.threadId === "string" && !!replied.threadId &&
      replied.visitorKey === undefined && res.owner === ownerScope &&
      validConsultation(replied.consultation) && replied.consultation.id === replied.threadId &&
      typeof replied.sentAt === "string" && !!replied.sentAt &&
      (payload.startNew === true || !payload.threadId || replied.threadId === payload.threadId);
    if (!accepted) {
      err.textContent = t("send_uncertain"); draftCarried = true; keepDraft();
      afterMemberSend(); loadMember(); return;
    }
    clearSent(sentScope, sentGeneration);
    hasConversation = true; newConversation = false; threadLoaded = true;
    topic = ""; draftCarried = false; draftLostImage = false; draftRestored = false; draftSwitched = false;
    selectedOrder = ""; orderNote = "";
    threadId = replied.threadId; threadState = "open"; loadEpoch++;
    adoptConsultation(replied.consultation);
    ta.value = ""; ta.style.height = "auto"; clearImage();
    intake();
    if (root.classList.contains("on")) ta.focus();
    lastSnapshot = "";
    afterMemberSend();
    loadMember();
  }
  function afterMemberSend() {
    sending = false; ta.readOnly = false; updateAvailability();
    if (root.classList.contains("on") && root.classList.contains("talking")) startPoll();
  }
  /* 会員のご相談の終了。公開APIと同じく、最後の発言が変わっていれば止める。 */
  async function closeMember() {
    if (!memberReady || !csrfToken || memberBusy || authBusy) { err.textContent = t("account_error"); return; }
    ending = true; loadEpoch++; stopPoll(); err.textContent = ""; updateAvailability();
    var id = endSnapshot.threadId;
    var res = await callMember({ timeout: 12000, body: { action: "close", csrfToken: csrfToken,
      threadId: id, lastMessageId: endSnapshot.lastMessageId, lastMessageAt: endSnapshot.lastMessageAt } });
    if (res.failure === "stale") return;
    ending = false;
    if (res.failure) {
      confirmEnd = false;
      if (res.failure === "token_expired") { err.textContent = t("token_expired"); bootstrapMember(); }
      else if (res.failure === "login_required" || res.failure === "owner") { handleMemberFailure(res); return; }
      else if (res.status === 409) err.textContent = t("end_changed");
      else if (res.failure !== "stale") err.textContent = t("end_error");
    } else if (res.body.ok !== true || res.body.threadId !== id || res.body.state !== "closed") {
      confirmEnd = false; err.textContent = t("end_error");
    } else {
      threadState = "closed"; confirmEnd = false; newConversation = false;
      ta.value = ""; clearImage();
      topic = ""; draftCarried = false; draftLostImage = false; draftRestored = false; draftSwitched = false;
      dropDraft();
      adoptConsultation(res.body.consultation);
    }
    updateAvailability(); load();
    if (root.classList.contains("on") && root.classList.contains("talking")) {
      startPoll(); document.getElementById(threadState === "closed" ? "lc-new" : "lc-end").focus();
    }
  }

  /* 初めて相談する方にだけ、連絡先の欄を出す。
     🔴 会員のご相談では伺わない（どなたかは署名付きの確認で済んでいる）。 */
  function intake() {
    var box = document.getElementById("lc-intake");
    if (!box) return;
    if (hasConversation || mode === "member") box.setAttribute("hidden", "");
    else box.removeAttribute("hidden");
  }

  function updateAvailability() {
    var start = root.querySelector(".lc-start");
    /* 🔴 設定の取得中・通信失敗を受付休止と表示しない。失敗時は入口から再接続できる。 */
    start.disabled = !key() && (configReady ? !chatEnabled : !configFailed);
    start.textContent = key() ? t("continue") : !configReady
      ? configFailed ? document.getElementById("lc-retry").textContent : t("connecting")
      : chatEnabled ? t("start") : t("unavailable");
    start.setAttribute("aria-busy", String(!key() && !configReady && !configFailed));
    var ended = threadState === "closed" && !newConversation;
    var blocked = ending || confirmEnd || ended;
    document.getElementById("lc-end-actions").hidden = !threadId || newConversation;
    document.getElementById("lc-end").hidden = ended || confirmEnd;
    document.getElementById("lc-end").disabled = sending || claiming || ending || !lastMessageId || !lastMessageAt;
    document.getElementById("lc-end-confirm").hidden = !confirmEnd;
    document.getElementById("lc-ended").hidden = !ended;
    document.getElementById("lc-composer").hidden = ended || confirmEnd;
    document.getElementById("lc-end-submit").disabled = ending;
    document.getElementById("lc-end-cancel").disabled = ending;
    document.getElementById("lc-new").disabled = !configReady || !chatEnabled || ending;
    /* 🔴 結果不明を持ち越している間は送れない。続けるには履歴を確認したと伺う。
       送信ボタンを二度押すと警告が消えて送れる、という隠れた道を作らない。 */
    /* 会員のご相談は、署名付きの確認（bootstrap）が通っているあいだだけ送れる。 */
    var memberBlocked = mode === "member" && (!memberReady || !csrfToken || memberBusy || authBusy);
    send.disabled = sending || claiming || blocked || !configReady || !chatEnabled || !threadLoaded || draftCarried ||
      !!attempt || overLimit() > 0 || memberBlocked || (!ta.value.trim() && !selectedImage);
    document.getElementById("lc-image-attach").disabled = sending || blocked || !configReady || !chatEnabled;
    document.getElementById("lc-image-remove").disabled = sending;
    ta.disabled = blocked || !configReady || !chatEnabled;
    ta.readOnly = sending || claiming;
    document.getElementById("lc-talk-status").textContent = ending ? t("end_saving") : document.getElementById("lc-config-status").textContent;
    document.getElementById("lc-retry").hidden = !configFailed || !key();
    document.getElementById("lc-retry-talk").hidden = !configFailed;
    syncDraft();
    syncAccount();
  }

  function finishConversation() {
    if (ending || sending || !confirmEnd || !threadId) return;
    if (mode === "member") { closeMember(); return; }
    ending = true; loadEpoch++; stopPoll(); err.textContent = ""; updateAvailability();
    var id = endSnapshot.threadId, requestEpoch = memberEpoch;
    fetch(API, { method: "POST", credentials: "omit", signal: AbortSignal.timeout(12000),
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "close", visitorKey: key(), threadId: id,
        lastMessageAt: endSnapshot.lastMessageAt, lastMessageId: endSnapshot.lastMessageId }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(r.status === 409 ? t("end_changed") : t("end_error")); return j; }); })
      .then(function (j) {
        if (mode !== "guest" || requestEpoch !== memberEpoch) return;
        if (!j.ok || j.threadId !== id || j.state !== "closed") throw new Error(t("end_error"));
        threadState = "closed"; confirmEnd = false; newConversation = false;
        ta.value = ""; clearImage();
        /* 終了した相談の書きかけは残さない。次のご相談へ古い本文を持ち込まない。 */
        topic = ""; draftCarried = false; draftLostImage = false; draftRestored = false; draftSwitched = false;
        dropDraft();
      })
      .catch(function (e) {
        if (mode !== "guest" || requestEpoch !== memberEpoch) return;
        confirmEnd = false; err.textContent = e.message === t("end_changed") ? e.message : t("end_error");
      })
      .finally(function () {
        if (mode !== "guest" || requestEpoch !== memberEpoch) return;
        ending = false; updateAvailability(); load();
        if (root.classList.contains("on") && root.classList.contains("talking")) {
          startPoll(); document.getElementById(threadState === "closed" ? "lc-new" : "lc-end").focus();
        }
      });
  }

  function prepareEmailContact(link) {
    if (!/^mailto:/i.test(link.href) || link.hasAttribute("data-lc-mail-ready")) return;
    var address;
    try { address = decodeURIComponent(new URL(link.href).pathname); } catch (e) { return; }
    if (!/^[^@\s?]+@[^@\s?]+\.[^@\s?]+$/.test(address)) return;
    var ja = !document.documentElement.lang || /^ja/i.test(document.documentElement.lang);
    var labels = ja ? ["メールでお問い合わせ", "ご利用のメールをお選びください。", "メールアプリで開く", "Gmailで作成", "アドレスをコピー", "コピーしました", "こちらのアドレスを選択してコピーしてください。"]
      : ["Contact us by email", "Choose how to compose your email.", "Open email app", "Compose in Gmail", "Copy email address", "Copied", "Select and copy this email address."];
    var box = document.createElement("div"), hint = document.createElement("p"), actions = document.createElement("div");
    box.className = "lc-mail-options"; box.hidden = true; box.setAttribute("role", "group"); box.setAttribute("aria-label", labels[0]);
    box.id = "lc-mail-options-" + (++mailControlId);
    hint.textContent = labels[1]; actions.className = "lc-mail-actions";
    var app = document.createElement("a"), gmail = document.createElement("a"), copy = document.createElement("button"), status = document.createElement("p");
    app.href = link.href; app.textContent = labels[2];
    gmail.href = "https://mail.google.com/mail/?view=cm&fs=1&to=" + encodeURIComponent(address);
    gmail.target = "_blank"; gmail.rel = "noopener noreferrer"; gmail.textContent = labels[3];
    copy.type = "button"; copy.textContent = labels[4]; status.className = "lc-mail-status"; status.setAttribute("role", "status");
    copy.addEventListener("click", async function () {
      try { await navigator.clipboard.writeText(address); status.textContent = labels[5]; }
      catch (e) {
        status.textContent = labels[6];
        var field = box.querySelector("input");
        if (!field) { field = document.createElement("input"); field.type = "text"; field.readOnly = true; field.value = address; field.setAttribute("aria-label", labels[0]); box.append(field); }
        field.focus(); field.select();
      }
    });
    actions.append(app, gmail, copy); box.append(hint, actions, status); link.parentElement.append(box);
    link.setAttribute("data-lc-mail-ready", ""); link.setAttribute("aria-expanded", "false"); link.setAttribute("aria-controls", box.id);
    // 🔴 mailtoだけではメールアプリ未設定の端末で反応が見えない。必ず画面上に選択肢を開く。
    link.addEventListener("click", function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); box.hidden = !box.hidden; link.setAttribute("aria-expanded", String(!box.hidden));
    });
  }

  function renderLinks(selector, links, contact) {
    var list = root.querySelector(selector);
    if (contact) lineContactUrl = "";
    var nodes = links.filter(function (item) { return !/^tel:/i.test(item.url); }).map(function (item) {
      var url = new URL(item.url);
      if (!["https:", "mailto:", "tel:"].includes(url.protocol) || url.username || url.password) throw new Error();
      var li = document.createElement("li"), a = document.createElement("a"), icon = document.createElement("span");
      a.href = url.href;
      if (url.protocol === "https:" && url.origin !== location.origin) { a.target = "_blank"; a.rel = "noopener"; }
      if (contact) prepareLineContact(a, url);
      icon.className = contact ? "lc-ic" : "lc-ar";
      icon.setAttribute("aria-hidden", "true");
      if (contact && contactIcons[url.protocol]) icon.append(contactIcons[url.protocol].cloneNode(true));
      else icon.textContent = "›";
      a.append(icon, document.createTextNode(item.label)); li.append(a);
      if (contact) prepareEmailContact(a);
      return li;
    });
    list.replaceChildren.apply(list, nodes);
  }

  function stopConfigRetry() {
    if (configRetryTimer !== null) clearTimeout(configRetryTimer);
    configRetryTimer = null;
  }
  function fetchConfig() {
    /* 🔴 AbortSignal.timeout非対応の端末でも同期例外で入口を止めない。
       タイムアウトは本文の読込まで含め、遅れて届いた応答も適用しない。 */
    var controller = typeof AbortController === "function" ? new AbortController() : null, timer;
    return Promise.race([
      Promise.resolve().then(function () {
        return fetch(API + "?config=1", { credentials: "omit", cache: "no-store", signal: controller ? controller.signal : undefined });
      }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); }),
      new Promise(function (resolve, reject) {
        timer = setTimeout(function () { if (controller) controller.abort(); reject(new Error()); }, 12000);
      }),
    ]).finally(function () { clearTimeout(timer); });
  }
  function refreshConfig(automatic) {
    if (configRequest) return configRequest;
    stopConfigRetry();
    if (automatic !== true) configRetries = 0;
    configReady = false; configFailed = false;
    var status = document.getElementById("lc-config-status"), retry = document.getElementById("lc-retry");
    status.textContent = t("connecting"); retry.hidden = true;
    updateAvailability();
    configRequest = fetchConfig()
      .then(function (json) {
        var config = json.config;
        if (!config || typeof config.chatEnabled !== "boolean" || !Array.isArray(config.links) || !Array.isArray(config.contacts)) throw new Error();
        lineWelcomeEnabled = !!(config.lineWelcome && config.lineWelcome.enabled && C.line && C.line.entryUrl);
        /* 🔴 LOOMがこの契約に対応していると分かったときだけ、新しい入口と状況表示を出す。
           旗が無い（古い）応答では第1段階のままにする。account は proxy の用意ができている印で、
           これ自体が「どなたか」を示すものではない。 */
        var features = json.features;
        accountEnabled = !!(features && features.account === true) && !!memberUrl();
        workflowEnabled = !!(features && features.workflow === true);
        renderLinks(".lc-list", config.links, false); renderLinks(".lc-ways", config.contacts, true);
        root.querySelector(".lc-h").textContent = config.title;
        root.querySelector(".lc-hours").textContent = config.notice;
        root.querySelector(".lc-sec").hidden = config.contacts.length === 0;
        configReady = true; chatEnabled = config.chatEnabled;
        status.textContent = chatEnabled ? "" : t("paused");
      })
      .catch(function () {
        chatEnabled = false; configFailed = true;
        /* 設定が読めないあいだは、新しい入口も状況表示も出さない。 */
        accountEnabled = false; workflowEnabled = false;
        status.textContent = t("config_error"); retry.hidden = false;
        // 設定の読取だけを最大2回再試行。送信・LINEの案内は自動再送しない。
        if (root.classList.contains("on") && !document.hidden && configRetries < 2) {
          var delay = [1000, 3000][configRetries++];
          configRetryTimer = setTimeout(function () {
            configRetryTimer = null;
            if (root.classList.contains("on") && !document.hidden) refreshConfig(true);
          }, delay);
        }
      })
      .finally(function () { configRequest = null; updateAvailability(); });
    return configRequest;
  }

  function clearImage() {
    selectedImage = null;
    /* 選び直し・取り消しのあとは「添付は戻りません」の断りを続けない。 */
    draftLostImage = false;
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    previewUrl = "";
    document.getElementById("lc-image-input").value = "";
    document.getElementById("lc-preview-photo").removeAttribute("src");
    document.getElementById("lc-image-preview").hidden = true;
    /* 🔴 ここで保存し直さない。送信後・終了後・新規相談でも呼ばれるので、
       その場の空の入力で、これから読み戻す下書きを消してしまう。 */
    updateAvailability();
  }
  function init() {
    root = document.getElementById("lc"); if (!root) return;
    scrim = document.getElementById("lc-scrim");
    btn = document.getElementById("lc-open");
    log = document.getElementById("lc-log");
    ta = document.getElementById("lc-ta");
    send = document.getElementById("lc-send");
    err = document.getElementById("lc-err");

    root.querySelectorAll(".lc-ways a").forEach(function (a) {
      var svg = a.querySelector("svg");
      if (svg) contactIcons[new URL(a.href).protocol] = svg.cloneNode(true);
      var destination = a.getAttribute("data-lc-line-url");
      if (destination) prepareLineContact(a, new URL(destination));
      prepareEmailContact(a);
    });
    strings = JSON.parse(document.getElementById("lc-strings").textContent);
    prepareLineLoginReturn();
    continueLineContact();
    root.inert = true;
    window.addEventListener("resize", fitViewport);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", fitViewport);
      window.visualViewport.addEventListener("scroll", fitViewport);
    }
    btn.addEventListener("click", open);
    scrim.addEventListener("click", close);
    root.querySelector(".lc-x").addEventListener("click", close);
    root.querySelector(".lc-start").addEventListener("click", startTalk);
    document.getElementById("lc-retry").addEventListener("click", refreshConfig);
    document.getElementById("lc-retry-talk").addEventListener("click", refreshConfig);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { stopPoll(); stopConfigRetry(); }
      else if (root.classList.contains("on")) {
        if (!configReady) refreshConfig();
        if (mode === "member" && !authBusy) refreshMember();
        if (root.classList.contains("talking")) { load(); startPoll(); }
      }
    });
    window.addEventListener("focus", function () {
      if (!document.hidden && root.classList.contains("on") && mode === "member" && !authBusy) refreshMember();
    });
    window.addEventListener("online", function () {
      if (!document.hidden && root.classList.contains("on") && !configReady) refreshConfig();
    });
    document.addEventListener("click", function (event) {
      var link = event.target.closest && event.target.closest("a[href]");
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var url = new URL(link.href, location.href);
      if (legacySupport(url) || (url.origin === location.origin && url.pathname === location.pathname && url.hash === supportHash)) {
        event.preventDefault(); openFromLink(link);
      }
    });
    prepareSupportLinks(document);
    retireLegacyChat();
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        change.addedNodes.forEach(function (node) { if (node.nodeType === 1) prepareSupportLinks(node); });
      });
      retireLegacyChat();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener("hashchange", function () {
      if (readResumeHash()) { openForResume(); return; }
      if (location.hash === supportHash) openFromLink();
    });
    /* 🔴 ほかの端末から渡されたリンク。IDはこのタブに預けてURLから外す。
       ログインを挟んで戻ってきたときも、同じIDで開き直せるようにする。 */
    var linkedResume = readResumeHash();
    if (linkedResume || (pendingResume() && C.account && C.account.hint === true)) openForResume();
    else if (claimReturnId()) {
      open(); refreshConfig().then(function () { if (mode === "guest") startTalk(); });
    } else if (location.hash === supportHash) openFromLink();
    root.querySelector(".lc-back").addEventListener("click", function () {
      if (mode === "member") { backToMemberList(); return; }
      talk(false);
    });
    root.querySelector(".lc-member-back").addEventListener("click", leaveMember);
    document.getElementById("lc-account-entry").addEventListener("click", function () { enterMember(true); });
    document.getElementById("lc-member-retry").addEventListener("click", function () { enterMember(true); });
    document.getElementById("lc-conv-more").addEventListener("click", function () { loadMore("conversations"); });
    document.getElementById("lc-order-more").addEventListener("click", function () { loadMore("orders"); });
    document.getElementById("lc-member-start").addEventListener("click", startMemberConsultation);
    document.getElementById("lc-conv-list").addEventListener("click", function (event) {
      var row = event.target.closest && event.target.closest("[data-lc-thread]");
      if (row) openMemberThread(row.getAttribute("data-lc-thread"));
    });
    /* ご注文を選ぶ。続いている相談の「変更」から来たときは、その場で結び付けを変える。 */
    document.getElementById("lc-order-list").addEventListener("click", function (event) {
      var row = event.target.closest && event.target.closest("[data-lc-order]");
      if (!row) return;
      var id = row.getAttribute("data-lc-order");
      if (orderLinking) { linkOrder(id); return; }
      selectedOrder = id; orderNote = "";
      keepDraft(); updateAvailability();
    });
    document.getElementById("lc-consult-order-change").addEventListener("click", function () {
      if (!memberReady || !threadId) return;
      orderLinking = true;
      root.classList.remove("talking"); root.classList.add("member");
      stopPoll(); updateAvailability();
      var first = document.querySelector("#lc-order-list [data-lc-order]");
      (first || memberBack()).focus();
    });
    document.getElementById("lc-resume-copy").addEventListener("click", copyResume);
    document.getElementById("lc-claim-save").addEventListener("click", claimConversation);
    document.getElementById("lc-claim-login").addEventListener("click", markClaimReturn);
    send.addEventListener("click", submit);
    document.getElementById("lc-end").addEventListener("click", function () {
      if (sending || ending || !threadId || threadState === "closed") return;
      endSnapshot = { threadId: threadId, lastMessageAt: lastMessageAt, lastMessageId: lastMessageId };
      confirmEnd = true; err.textContent = ""; updateAvailability();
      document.getElementById("lc-end-cancel").focus();
    });
    document.getElementById("lc-end-cancel").addEventListener("click", function () {
      if (ending) return; confirmEnd = false; updateAvailability(); ta.focus();
    });
    document.getElementById("lc-end-submit").addEventListener("click", finishConversation);
    document.getElementById("lc-new").addEventListener("click", function () {
      if (ending || threadState !== "closed" || !configReady || !chatEnabled) return;
      /* 会員のご相談は、対象のご注文を選び直せる一覧から始める。 */
      if (mode === "member") { backToMemberList(); return; }
      loadEpoch++; newConversation = true; lastSnapshot = ""; ta.value = ""; clearImage();
      /* 新しい相談は専用の置き場所。終わった相談の本文は読まず、この相談の書きかけだけを戻す。 */
      topic = ""; draftCarried = false; draftLostImage = false; draftRestored = false; draftSwitched = false;
      restoreDraft();
      err.textContent = ""; render([]); updateAvailability(); ta.focus();
    });
    var imageInput = document.getElementById("lc-image-input");
    document.getElementById("lc-image-attach").addEventListener("click", function () { if (!sending) imageInput.click(); });
    document.getElementById("lc-image-remove").addEventListener("click", function () { if (!sending) { clearImage(); keepDraft(); } });
    imageInput.addEventListener("change", function () {
      if (sending) return;
      var file = imageInput.files[0]; if (!file) return;
      if (!["image/jpeg", "image/png", "image/webp"].includes(file.type) || !file.size || file.size > 5 * 1024 * 1024) {
        err.textContent = t("image_invalid"); imageInput.value = ""; return;
      }
      clearImage(); selectedImage = file; previewUrl = URL.createObjectURL(file);
      document.getElementById("lc-preview-photo").src = previewUrl;
      document.getElementById("lc-image-name").textContent = file.name;
      document.getElementById("lc-image-preview").hidden = false; err.textContent = "";
      keepDraft();
      updateAvailability();
    });
    /* 内容があるときだけ送信できるようにする。高さは fitComposer が合わせる。 */
    ta.addEventListener("input", function () {
      fitComposer();
      /* 書き始めたら「復元しました」は役目を終える。結果不明の断りはそのまま残す。 */
      draftRestored = false;
      keepDraft();
      updateAvailability();
    });
    ta.addEventListener("keydown", function (e) {
      /* 🔴 日本語変換の確定Enterで送らない */
      if (e.key === "Enter" && (e.metaKey || e.ctrlKey) && !e.isComposing) { e.preventDefault(); submit(); }
    });
    document.addEventListener("keydown", function (e) {
      if (!root.classList.contains("on")) return;
      if (e.key === "Escape") { e.preventDefault(); close(); }
      if (e.key === "Tab") {
        var focusable = Array.from(root.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),textarea:not(:disabled)'))
          .filter(function (el) { return el.getClientRects().length && !el.closest("[hidden]"); });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    /* ご用件は押すたびに切り替える。同じものをもう一度押すと選択を外す。
       選んだ時点では本文に触らないので、画面を行き来しても書きかけは残る。 */
    topicButtons().forEach(function (button) {
      button.addEventListener("click", function () {
        var id = button.getAttribute("data-lc-topic");
        if (!topicEligible()) return;
        var chosen = topic !== id;
        topic = chosen ? id : "";
        keepDraft(); updateAvailability();
        if (chosen) startTalk(); else button.focus();
      });
    });
    /* ご用件の変更は入口の選択へ戻るだけ。本文はそのまま残す。 */
    document.getElementById("lc-topic-change").addEventListener("click", function () {
      talk(false);
      var pressed = root.querySelector('[data-lc-topic][aria-pressed="true"]');
      if (pressed) pressed.focus();
    });

    /* 結果不明を持ち越したときだけ出る。履歴を確認したと伺ってから送信を開く。 */
    document.getElementById("lc-draft-confirm").addEventListener("click", function () {
      if (!draftCarried) return;
      draftCarried = false; draftRestored = false; draftSwitched = false;
      keepDraft(true); err.textContent = ""; updateAvailability(); ta.focus();
    });
    /* 別の会話に残った未解消の試行の結末を、利用者が選ぶ。
       🔴 どちらもこちらからの送信は行わない。「戻す」は選ばれたときだけ本文を移す。 */
    document.getElementById("lc-attempt-keep").addEventListener("click", function () {
      if (!attempt) return;
      dropDraft(attempt.scope);
      /* 🔴 まだ別の未解消の試行が残っていれば、続けてそれを示す（送信も開けない）。 */
      attempt = findAttempt();
      err.textContent = ""; updateAvailability(); ta.focus();
    });
    document.getElementById("lc-attempt-restore").addEventListener("click", function () {
      if (!attempt || (ta && ta.value)) return;
      var moved = attempt.item;
      dropDraft(attempt.scope);
      ta.value = moved.body;
      fitComposer();
      if (moved.topic && topicLabel(moved.topic) && firstMessage()) topic = moved.topic;
      draftLostImage = !!moved.image; draftRestored = true; draftCarried = false; draftSwitched = false;
      keepDraft(true);
      /* 🔴 ほかに未解消の試行が残っていれば、続けてそれを示す。 */
      attempt = findAttempt();
      err.textContent = ""; updateAvailability(); ta.focus();
    });

    /* 前回の続きがあれば、開いたときすぐ会話に入る */
    if (key()) root.querySelector(".lc-start").textContent = t("continue");
    /* 書きかけを戻すのは、今の会話が読めたあと（load → resolveDraft）。ここでは画面を揃えるだけ。 */
    intake(); syncDraft();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
